// src/enums.ts
var UserRole = {
  ADMIN: "ADMIN",
  DIETITIAN: "DIETITIAN",
  CLIENT: "CLIENT"
};
var UserStatus = {
  /** Davet gönderildi, şifre henüz belirlenmedi */
  INVITED: "INVITED",
  ACTIVE: "ACTIVE",
  /** Paketi bitti veya yönetici pasife aldı */
  PASSIVE: "PASSIVE",
  SUSPENDED: "SUSPENDED"
};
var ServiceType = {
  ONLINE: "ONLINE",
  IN_PERSON: "IN_PERSON"
};
var PackageStatus = {
  /** Ödeme doğrulanmadı, erişim açılmadı */
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  EXPIRING_SOON: "EXPIRING_SOON",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED"
};
var PaymentMethod = {
  TRANSFER: "TRANSFER",
  CARD: "CARD",
  CASH: "CASH",
  OTHER: "OTHER"
};
var PaymentStatus = {
  PENDING: "PENDING",
  VERIFIED: "VERIFIED",
  REFUNDED: "REFUNDED",
  FAILED: "FAILED"
};
var PlanStatus = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED"
};
var MealSlot = {
  BREAKFAST: "BREAKFAST",
  MORNING_SNACK: "MORNING_SNACK",
  LUNCH: "LUNCH",
  AFTERNOON_SNACK: "AFTERNOON_SNACK",
  DINNER: "DINNER",
  EVENING_SNACK: "EVENING_SNACK"
};
var MEAL_SLOT_ORDER = [
  MealSlot.BREAKFAST,
  MealSlot.MORNING_SNACK,
  MealSlot.LUNCH,
  MealSlot.AFTERNOON_SNACK,
  MealSlot.DINNER,
  MealSlot.EVENING_SNACK
];
var MealLogStatus = {
  PLANNED: "PLANNED",
  COMPLETED: "COMPLETED",
  SKIPPED: "SKIPPED"
};
var PhotoReviewStatus = {
  UPLOADING: "UPLOADING",
  PENDING: "PENDING",
  REVIEWED: "REVIEWED"
};
var MessageType = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  MEAL_PHOTO: "MEAL_PHOTO",
  CALL_LOG: "CALL_LOG",
  SYSTEM: "SYSTEM",
  ANNOUNCEMENT: "ANNOUNCEMENT"
};
var QuestionStatus = {
  OPEN: "OPEN",
  ANSWERED: "ANSWERED",
  CLOSED: "CLOSED"
};
var QuestionPriority = {
  NORMAL: "NORMAL",
  HIGH: "HIGH",
  URGENT: "URGENT"
};
var ExchangeGroupKey = {
  SUT: "SUT",
  ET: "ET",
  EKMEK: "EKMEK",
  TAHIL: "TAHIL",
  SEBZE: "SEBZE",
  MEYVE: "MEYVE",
  YAG: "YAG"
};
var EXCHANGE_GROUP_LABELS = {
  SUT: "S\xFCt grubu",
  ET: "Et grubu",
  EKMEK: "Ekmek grubu",
  TAHIL: "Tah\u0131l grubu",
  SEBZE: "Sebze grubu",
  MEYVE: "Meyve grubu",
  YAG: "Ya\u011F grubu"
};
var EXCHANGE_GROUP_ORDER = [
  "SUT",
  "ET",
  "EKMEK",
  "TAHIL",
  "SEBZE",
  "MEYVE",
  "YAG"
];
var DietaryRuleKind = {
  /** Yenilmemesi gereken besinler. */
  FORBIDDEN: "FORBIDDEN",
  /** Porsiyona sayilmadan serbestce tuketilebilenler. */
  FREE: "FREE"
};
var CallMedia = {
  AUDIO: "AUDIO",
  VIDEO: "VIDEO"
};
var CallStatus = {
  RINGING: "RINGING",
  ACTIVE: "ACTIVE",
  ENDED: "ENDED",
  MISSED: "MISSED",
  DECLINED: "DECLINED",
  FAILED: "FAILED"
};
var AppointmentType = {
  ONLINE_CALL: "ONLINE_CALL",
  IN_PERSON: "IN_PERSON"
};
var AppointmentStatus = {
  SCHEDULED: "SCHEDULED",
  RESCHEDULE_REQUESTED: "RESCHEDULE_REQUESTED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  NO_SHOW: "NO_SHOW"
};
var NotificationEvent = {
  PLAN_PUBLISHED: "PLAN_PUBLISHED",
  NEW_MESSAGE: "NEW_MESSAGE",
  NEW_QUESTION: "NEW_QUESTION",
  QUESTION_OVERDUE: "QUESTION_OVERDUE",
  MEAL_REMINDER: "MEAL_REMINDER",
  MEAL_PHOTO_UPLOADED: "MEAL_PHOTO_UPLOADED",
  MEAL_FEEDBACK_READY: "MEAL_FEEDBACK_READY",
  APPOINTMENT_UPCOMING: "APPOINTMENT_UPCOMING",
  APPOINTMENT_CHANGED: "APPOINTMENT_CHANGED",
  MEASUREMENT_DUE: "MEASUREMENT_DUE",
  MEASUREMENT_PUBLISHED: "MEASUREMENT_PUBLISHED",
  PACKAGE_EXPIRING: "PACKAGE_EXPIRING",
  PACKAGE_EXPIRED: "PACKAGE_EXPIRED",
  INVITATION_PENDING: "INVITATION_PENDING",
  WATER_GOAL_REMINDER: "WATER_GOAL_REMINDER",
  STREAK_MILESTONE: "STREAK_MILESTONE",
  WEEKLY_REPORT_READY: "WEEKLY_REPORT_READY",
  MISSED_CALL: "MISSED_CALL",
  ANNOUNCEMENT: "ANNOUNCEMENT"
};
var NotificationAudience = {
  CLIENT: "CLIENT",
  DIETITIAN: "DIETITIAN",
  ADMIN: "ADMIN"
};
var NotificationTiming = {
  /** Olay anında */
  IMMEDIATE: "IMMEDIATE",
  /** Olaydan N dakika önce */
  BEFORE: "BEFORE",
  /** Olay günü belirli saatte */
  ON_DAY: "ON_DAY",
  /** Olaydan N dakika sonra (ör. yanıtlanmayan soru) */
  AFTER: "AFTER"
};
var NotificationChannel = {
  IN_APP: "IN_APP",
  PUSH: "PUSH",
  EMAIL: "EMAIL"
};
var DeliveryStatus = {
  QUEUED: "QUEUED",
  SENT: "SENT",
  FAILED: "FAILED",
  SKIPPED: "SKIPPED"
};
var ActivityLevel = {
  SEDENTARY: "SEDENTARY",
  LIGHT: "LIGHT",
  MODERATE: "MODERATE",
  ACTIVE: "ACTIVE",
  VERY_ACTIVE: "VERY_ACTIVE"
};
var ClientGoal = {
  WEIGHT_LOSS: "WEIGHT_LOSS",
  WEIGHT_GAIN: "WEIGHT_GAIN",
  MAINTENANCE: "MAINTENANCE",
  MUSCLE_GAIN: "MUSCLE_GAIN",
  MEDICAL_NUTRITION: "MEDICAL_NUTRITION",
  SPORTS_NUTRITION: "SPORTS_NUTRITION",
  PREGNANCY: "PREGNANCY"
};
var DietaryPreference = {
  NONE: "NONE",
  VEGETARIAN: "VEGETARIAN",
  VEGAN: "VEGAN",
  PESCATARIAN: "PESCATARIAN",
  GLUTEN_FREE: "GLUTEN_FREE",
  LACTOSE_FREE: "LACTOSE_FREE",
  KETO: "KETO",
  LOW_CARB: "LOW_CARB",
  HALAL: "HALAL",
  MEDITERRANEAN: "MEDITERRANEAN"
};
var ConsentType = {
  TERMS: "TERMS",
  PRIVACY: "PRIVACY",
  /** Özel nitelikli sağlık verisi için açık rıza */
  HEALTH_DATA: "HEALTH_DATA",
  MARKETING: "MARKETING"
};
var DataRequestType = {
  EXPORT: "EXPORT",
  DELETION: "DELETION"
};
var DataRequestStatus = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED"
};
var BadgeCode = {
  FIRST_MEAL_LOGGED: "FIRST_MEAL_LOGGED",
  FIRST_PHOTO: "FIRST_PHOTO",
  PERFECT_DAY: "PERFECT_DAY",
  WEEK_STREAK_1: "WEEK_STREAK_1",
  WEEK_STREAK_4: "WEEK_STREAK_4",
  WEEK_STREAK_12: "WEEK_STREAK_12",
  HYDRATION_HERO: "HYDRATION_HERO",
  MEASUREMENT_REGULAR: "MEASUREMENT_REGULAR",
  GOAL_REACHED: "GOAL_REACHED",
  EARLY_BIRD: "EARLY_BIRD"
};
var AuditAction = {
  USER_INVITED: "USER_INVITED",
  USER_ACTIVATED: "USER_ACTIVATED",
  USER_SUSPENDED: "USER_SUSPENDED",
  USER_LOGIN: "USER_LOGIN",
  USER_LOGIN_FAILED: "USER_LOGIN_FAILED",
  PACKAGE_CREATED: "PACKAGE_CREATED",
  PACKAGE_ACTIVATED: "PACKAGE_ACTIVATED",
  PAYMENT_VERIFIED: "PAYMENT_VERIFIED",
  PLAN_PUBLISHED: "PLAN_PUBLISHED",
  PLAN_UPDATED: "PLAN_UPDATED",
  MEASUREMENT_CREATED: "MEASUREMENT_CREATED",
  MEASUREMENT_UPDATED: "MEASUREMENT_UPDATED",
  MEASUREMENT_PUBLISHED: "MEASUREMENT_PUBLISHED",
  APPOINTMENT_CREATED: "APPOINTMENT_CREATED",
  APPOINTMENT_UPDATED: "APPOINTMENT_UPDATED",
  FEEDBACK_SENT: "FEEDBACK_SENT",
  DATA_EXPORTED: "DATA_EXPORTED",
  DATA_DELETED: "DATA_DELETED",
  ROLE_CHANGED: "ROLE_CHANGED",
  NOTIFICATION_RULE_CHANGED: "NOTIFICATION_RULE_CHANGED"
};
var Locale = { TR: "tr", EN: "en" };

// src/badges.ts
var BADGE_META = {
  [BadgeCode.FIRST_MEAL_LOGGED]: {
    title: "\u0130lk ad\u0131m",
    description: "\u0130lk \xF6\u011F\xFCn\xFCn\xFCz\xFC i\u015Faretlediniz",
    howTo: "Plan\u0131n\u0131zdaki herhangi bir \xF6\u011F\xFCn\xFC tamamland\u0131 olarak i\u015Faretleyin.",
    icon: "utensils"
  },
  [BadgeCode.FIRST_PHOTO]: {
    title: "\u0130lk kare",
    description: "\u0130lk \xF6\u011F\xFCn foto\u011Fraf\u0131n\u0131z\u0131 g\xF6nderdiniz",
    howTo: "Bir \xF6\u011F\xFCn\xFCn\xFCz\xFCn foto\u011Fraf\u0131n\u0131 \xE7ekip diyetisyeninize g\xF6nderin.",
    icon: "camera"
  },
  [BadgeCode.PERFECT_DAY]: {
    title: "Tam g\xFCn",
    description: "Bir g\xFCn\xFCn t\xFCm \xF6\u011F\xFCnlerini tamamlad\u0131n\u0131z",
    howTo: "Bir g\xFCn\xFCn plan\u0131ndaki b\xFCt\xFCn \xF6\u011F\xFCnleri tamamland\u0131 olarak i\u015Faretleyin.",
    icon: "checkCircle"
  },
  [BadgeCode.WEEK_STREAK_1]: {
    title: "Bir hafta",
    description: "7 g\xFCn \xFCst \xFCste serinizi korudunuz",
    howTo: "Yedi g\xFCn boyunca hi\xE7 ara vermeden \xF6\u011F\xFCnlerinizi i\u015Faretleyin.",
    icon: "flame"
  },
  [BadgeCode.WEEK_STREAK_4]: {
    title: "Bir ay",
    description: "28 g\xFCn \xFCst \xFCste serinizi korudunuz",
    howTo: "Serinizi 28 g\xFCne ta\u015F\u0131y\u0131n; arada bir g\xFCn bile bo\u015F kalmas\u0131n.",
    icon: "flame"
  },
  [BadgeCode.WEEK_STREAK_12]: {
    title: "\xDC\xE7 ay",
    description: "84 g\xFCn \xFCst \xFCste serinizi korudunuz",
    howTo: "Serinizi 84 g\xFCne ta\u015F\u0131y\u0131n \u2014 \xFC\xE7 ay kesintisiz takip.",
    icon: "flame"
  },
  [BadgeCode.HYDRATION_HERO]: {
    title: "Su kahraman\u0131",
    description: "7 g\xFCn \xFCst \xFCste su hedefinize ula\u015Ft\u0131n\u0131z",
    howTo: "Yedi g\xFCn boyunca her g\xFCn g\xFCnl\xFCk su hedefinizi tamamlay\u0131n.",
    icon: "water"
  },
  [BadgeCode.MEASUREMENT_REGULAR]: {
    title: "D\xFCzenli takip",
    description: "4 hafta \xFCst \xFCste \xF6l\xE7\xFCm",
    howTo: "D\xF6rt hafta boyunca her hafta \xF6l\xE7\xFCm\xFCn\xFCz\xFC kaydettirin.",
    icon: "scale"
  },
  [BadgeCode.GOAL_REACHED]: {
    title: "Hedefe ula\u015Ft\u0131n",
    description: "Hedef kilonuza ula\u015Ft\u0131n\u0131z",
    howTo: "Diyetisyeninizle belirledi\u011Finiz hedef kiloya ula\u015F\u0131n.",
    icon: "award"
  },
  [BadgeCode.EARLY_BIRD]: {
    title: "Erkenci",
    description: "5 kez kahvalt\u0131y\u0131 09:00'dan \xF6nce tamamlad\u0131n\u0131z",
    howTo: "Be\u015F kez kahvalt\u0131n\u0131z\u0131 saat 09:00'dan \xF6nce tamamland\u0131 olarak i\u015Faretleyin.",
    icon: "clock"
  }
};
function isKnownBadge(code) {
  return code in BADGE_META;
}
function badgeMeta(code) {
  return isKnownBadge(code) ? BADGE_META[code] : null;
}
function badgeTitle(code) {
  return badgeMeta(code)?.title ?? null;
}

// src/constants.ts
var RULES = {
  /** Davet bağlantısının geçerlilik süresi (saat). */
  invitationTtlHours: 72,
  /** Şifre sıfırlama bağlantısı (dakika). */
  passwordResetTtlMinutes: 60,
  /** Erişim jetonu ömrü. */
  accessTokenTtl: "15m",
  /** Yenileme jetonu ömrü (gün). */
  refreshTokenTtlDays: 30,
  /** Paket bitişine kaç gün kala "yakında bitiyor" sayılır. */
  packageExpiringWindowDays: 7,
  /** Yanıtlanmayan soru kaç dakika sonra geciken sayılır. */
  questionOverdueMinutes: 120,
  /** Öğün fotoğrafı azami boyut (bayt). */
  maxPhotoBytes: 12 * 1024 * 1024,
  /** Sohbet eki azami boyut. */
  maxAttachmentBytes: 20 * 1024 * 1024,
  /** Bir günde izin verilen azami fotoğraf. */
  maxPhotosPerDay: 12,
  /** Varsayılan günlük su hedefi (ml). */
  defaultWaterGoalMl: 2500,
  /** Tek dokunuşla eklenen bardak (ml). */
  waterGlassMl: 250,
  /** Şifre en az bu kadar karakter. */
  minPasswordLength: 10,
  /** Ardışık hatalı girişten sonra kilit (dakika). */
  loginLockoutMinutes: 15,
  maxLoginAttempts: 5,
  /** Randevu varsayılan süresi. */
  defaultAppointmentMinutes: 30,
  /** Sayfalama. */
  defaultPageSize: 20,
  maxPageSize: 100,
  /** Sesli görüşme zil süresi (saniye). */
  callRingTimeoutSec: 45,
  /** Streak'in kırılmaması için gereken günlük asgari tamamlanan öğün oranı. */
  streakMinCompletionRatio: 0.6
};
var DEFAULT_MEAL_TIMES = {
  BREAKFAST: "08:00",
  MORNING_SNACK: "10:30",
  LUNCH: "12:30",
  AFTERNOON_SNACK: "16:00",
  DINNER: "19:00",
  EVENING_SNACK: "21:30"
};
var MEAL_SLOT_LABELS_TR = {
  BREAKFAST: "Kahvalt\u0131",
  MORNING_SNACK: "Ku\u015Fluk ara \xF6\u011F\xFCn",
  LUNCH: "\xD6\u011Fle yeme\u011Fi",
  AFTERNOON_SNACK: "\u0130kindi ara \xF6\u011F\xFCn",
  DINNER: "Ak\u015Fam yeme\u011Fi",
  EVENING_SNACK: "Gece ara \xF6\u011F\xFCn"
};
var MEAL_SLOT_LABELS_EN = {
  BREAKFAST: "Breakfast",
  MORNING_SNACK: "Morning snack",
  LUNCH: "Lunch",
  AFTERNOON_SNACK: "Afternoon snack",
  DINNER: "Dinner",
  EVENING_SNACK: "Evening snack"
};
var GROCERY_CATEGORIES = [
  "MEYVE_SEBZE",
  "ET_TAVUK_BALIK",
  "SUT_URUNLERI",
  "BAKLIYAT_TAHIL",
  "KURUYEMIS",
  "BAKKALIYE",
  "ICECEK",
  "DIGER"
];
var GROCERY_CATEGORY_LABELS_TR = {
  MEYVE_SEBZE: "Meyve & sebze",
  ET_TAVUK_BALIK: "Et, tavuk & bal\u0131k",
  SUT_URUNLERI: "S\xFCt \xFCr\xFCnleri",
  BAKLIYAT_TAHIL: "Bakliyat & tah\u0131l",
  KURUYEMIS: "Kuruyemi\u015F",
  BAKKALIYE: "Bakkaliye",
  ICECEK: "\u0130\xE7ecek",
  DIGER: "Di\u011Fer"
};
var DEFAULT_NOTIFICATION_RULES = [
  {
    event: NotificationEvent.PLAN_PUBLISHED,
    audience: NotificationAudience.CLIENT,
    timing: NotificationTiming.IMMEDIATE,
    offsetMinutes: 0,
    channels: ["IN_APP", "PUSH"],
    enabled: true
  },
  {
    event: NotificationEvent.NEW_MESSAGE,
    audience: NotificationAudience.CLIENT,
    timing: NotificationTiming.IMMEDIATE,
    offsetMinutes: 0,
    channels: ["IN_APP", "PUSH"],
    enabled: true
  },
  {
    event: NotificationEvent.NEW_QUESTION,
    audience: NotificationAudience.DIETITIAN,
    timing: NotificationTiming.IMMEDIATE,
    offsetMinutes: 0,
    channels: ["IN_APP", "PUSH"],
    enabled: true
  },
  {
    event: NotificationEvent.QUESTION_OVERDUE,
    audience: NotificationAudience.DIETITIAN,
    timing: NotificationTiming.AFTER,
    offsetMinutes: RULES.questionOverdueMinutes,
    channels: ["IN_APP", "PUSH"],
    enabled: true
  },
  {
    event: NotificationEvent.MEAL_PHOTO_UPLOADED,
    audience: NotificationAudience.DIETITIAN,
    timing: NotificationTiming.IMMEDIATE,
    offsetMinutes: 0,
    channels: ["IN_APP"],
    enabled: true
  },
  {
    event: NotificationEvent.MEAL_FEEDBACK_READY,
    audience: NotificationAudience.CLIENT,
    timing: NotificationTiming.IMMEDIATE,
    offsetMinutes: 0,
    channels: ["IN_APP", "PUSH"],
    enabled: true
  },
  {
    event: NotificationEvent.APPOINTMENT_UPCOMING,
    audience: NotificationAudience.CLIENT,
    timing: NotificationTiming.BEFORE,
    offsetMinutes: 240,
    channels: ["IN_APP", "PUSH"],
    enabled: true
  },
  {
    event: NotificationEvent.APPOINTMENT_CHANGED,
    audience: NotificationAudience.CLIENT,
    timing: NotificationTiming.IMMEDIATE,
    offsetMinutes: 0,
    channels: ["IN_APP", "PUSH"],
    enabled: true
  },
  {
    event: NotificationEvent.MEASUREMENT_DUE,
    audience: NotificationAudience.DIETITIAN,
    timing: NotificationTiming.ON_DAY,
    offsetMinutes: 9 * 60,
    channels: ["IN_APP"],
    enabled: true
  },
  {
    event: NotificationEvent.MEASUREMENT_PUBLISHED,
    audience: NotificationAudience.CLIENT,
    timing: NotificationTiming.IMMEDIATE,
    offsetMinutes: 0,
    channels: ["IN_APP", "PUSH"],
    enabled: true
  },
  {
    event: NotificationEvent.PACKAGE_EXPIRING,
    audience: NotificationAudience.ADMIN,
    timing: NotificationTiming.BEFORE,
    offsetMinutes: RULES.packageExpiringWindowDays * 24 * 60,
    channels: ["IN_APP", "EMAIL"],
    enabled: true
  },
  {
    event: NotificationEvent.MEAL_REMINDER,
    audience: NotificationAudience.CLIENT,
    timing: NotificationTiming.BEFORE,
    offsetMinutes: 15,
    channels: ["PUSH"],
    enabled: false
  },
  {
    event: NotificationEvent.WATER_GOAL_REMINDER,
    audience: NotificationAudience.CLIENT,
    timing: NotificationTiming.ON_DAY,
    offsetMinutes: 15 * 60,
    channels: ["PUSH"],
    enabled: false
  },
  {
    event: NotificationEvent.WEEKLY_REPORT_READY,
    audience: NotificationAudience.CLIENT,
    timing: NotificationTiming.IMMEDIATE,
    offsetMinutes: 0,
    channels: ["IN_APP", "PUSH"],
    enabled: true
  },
  {
    event: NotificationEvent.MISSED_CALL,
    audience: NotificationAudience.CLIENT,
    timing: NotificationTiming.IMMEDIATE,
    offsetMinutes: 0,
    channels: ["IN_APP", "PUSH"],
    enabled: true
  }
];
var SOCKET_EVENTS = {
  // bağlantı
  CONNECTED: "connected",
  ERROR: "error",
  // sohbet
  MESSAGE_NEW: "message:new",
  MESSAGE_SEND: "message:send",
  MESSAGE_ACK: "message:ack",
  MESSAGE_READ: "message:read",
  MESSAGE_READ_RECEIPT: "message:read-receipt",
  TYPING_START: "typing:start",
  TYPING_STOP: "typing:stop",
  PRESENCE_UPDATE: "presence:update",
  CONVERSATION_JOIN: "conversation:join",
  CONVERSATION_LEAVE: "conversation:leave",
  // sesli görüşme (WebRTC sinyalleşme)
  CALL_INVITE: "call:invite",
  CALL_INCOMING: "call:incoming",
  CALL_ACCEPT: "call:accept",
  CALL_ACCEPTED: "call:accepted",
  CALL_DECLINE: "call:decline",
  CALL_DECLINED: "call:declined",
  CALL_END: "call:end",
  CALL_ENDED: "call:ended",
  CALL_OFFER: "call:offer",
  CALL_ANSWER: "call:answer",
  CALL_ICE: "call:ice-candidate",
  CALL_STATE: "call:state",
  // canlı güncellemeler
  NOTIFICATION_NEW: "notification:new",
  PLAN_PUBLISHED: "plan:published",
  MEAL_LOG_UPDATED: "meallog:updated",
  QUESTION_QUEUE_UPDATED: "question-queue:updated",
  PHOTO_REVIEWED: "photo:reviewed"
};
var PERMISSIONS = {
  ADMIN: [
    "client:read:all",
    "client:write",
    "package:read",
    "package:write",
    "payment:write",
    "plan:read:all",
    "plan:write",
    "measurement:read:all",
    "measurement:write",
    "appointment:read:all",
    "appointment:write",
    "message:read:all",
    "message:write",
    "notification-rule:write",
    "report:read",
    "team:write",
    "audit:read",
    "template:write",
    "data-request:write"
  ],
  DIETITIAN: [
    "client:read:assigned",
    "client:write:assigned",
    "plan:read:assigned",
    "plan:write",
    "measurement:read:assigned",
    "measurement:write",
    "appointment:read:assigned",
    "appointment:write",
    "message:read:assigned",
    "message:write",
    "report:read:assigned",
    "template:write"
  ],
  CLIENT: [
    "self:read",
    "self:write",
    "plan:read:own",
    "meal-log:write:own",
    "photo:write:own",
    "message:read:own",
    "message:write:own",
    "measurement:read:own",
    "appointment:read:own",
    "appointment:request-change"
  ]
};

// src/errors.ts
var ErrorCode = {
  // kimlik
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
  ACCOUNT_LOCKED: "ACCOUNT_LOCKED",
  ACCOUNT_NOT_ACTIVATED: "ACCOUNT_NOT_ACTIVATED",
  ACCOUNT_SUSPENDED: "ACCOUNT_SUSPENDED",
  TOKEN_EXPIRED: "TOKEN_EXPIRED",
  TOKEN_INVALID: "TOKEN_INVALID",
  INVITATION_EXPIRED: "INVITATION_EXPIRED",
  INVITATION_ALREADY_USED: "INVITATION_ALREADY_USED",
  CONSENT_REQUIRED: "CONSENT_REQUIRED",
  // yetki
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",
  NOT_ASSIGNED_TO_CLIENT: "NOT_ASSIGNED_TO_CLIENT",
  // paket / erişim
  NO_ACTIVE_PACKAGE: "NO_ACTIVE_PACKAGE",
  PACKAGE_EXPIRED: "PACKAGE_EXPIRED",
  PAYMENT_NOT_VERIFIED: "PAYMENT_NOT_VERIFIED",
  // veri
  NOT_FOUND: "NOT_FOUND",
  VALIDATION_FAILED: "VALIDATION_FAILED",
  DUPLICATE_EMAIL: "DUPLICATE_EMAIL",
  DUPLICATE_RESOURCE: "DUPLICATE_RESOURCE",
  CONFLICT: "CONFLICT",
  APPOINTMENT_CONFLICT: "APPOINTMENT_CONFLICT",
  PLAN_INCOMPLETE: "PLAN_INCOMPLETE",
  PLAN_NOT_PUBLISHED: "PLAN_NOT_PUBLISHED",
  // yükleme
  FILE_TOO_LARGE: "FILE_TOO_LARGE",
  UNSUPPORTED_FILE_TYPE: "UNSUPPORTED_FILE_TYPE",
  UPLOAD_FAILED: "UPLOAD_FAILED",
  DAILY_PHOTO_LIMIT: "DAILY_PHOTO_LIMIT",
  // görüşme
  CALL_ALREADY_ACTIVE: "CALL_ALREADY_ACTIVE",
  CALL_NOT_AVAILABLE: "CALL_NOT_AVAILABLE",
  PEER_OFFLINE: "PEER_OFFLINE",
  // sistem
  RATE_LIMITED: "RATE_LIMITED",
  INTERNAL_ERROR: "INTERNAL_ERROR",
  SERVICE_UNAVAILABLE: "SERVICE_UNAVAILABLE",
  NETWORK_ERROR: "NETWORK_ERROR"
};
var ERROR_MESSAGES_TR = {
  INVALID_CREDENTIALS: "E-posta veya \u015Fifre hatal\u0131.",
  ACCOUNT_LOCKED: "\xC7ok fazla hatal\u0131 deneme yap\u0131ld\u0131. L\xFCtfen biraz sonra tekrar deneyin.",
  ACCOUNT_NOT_ACTIVATED: "Hesab\u0131n\u0131z hen\xFCz etkinle\u015Ftirilmedi. Davet ba\u011Flant\u0131n\u0131z\u0131 kullan\u0131n.",
  ACCOUNT_SUSPENDED: "Hesab\u0131n\u0131za eri\u015Fim durduruldu. L\xFCtfen merkezle ileti\u015Fime ge\xE7in.",
  TOKEN_EXPIRED: "Oturumunuzun s\xFCresi doldu. Tekrar giri\u015F yap\u0131n.",
  TOKEN_INVALID: "Ba\u011Flant\u0131 ge\xE7ersiz.",
  INVITATION_EXPIRED: "Davet ba\u011Flant\u0131s\u0131n\u0131n s\xFCresi dolmu\u015F. Yeni davet isteyin.",
  INVITATION_ALREADY_USED: "Bu davet daha \xF6nce kullan\u0131lm\u0131\u015F.",
  CONSENT_REQUIRED: "Devam etmek i\xE7in gerekli onaylar\u0131 vermeniz gerekiyor.",
  UNAUTHORIZED: "Bu i\u015Flem i\xE7in giri\u015F yapman\u0131z gerekiyor.",
  FORBIDDEN: "Bu i\u015Flem i\xE7in yetkiniz yok.",
  NOT_ASSIGNED_TO_CLIENT: "Bu dan\u0131\u015Fan size atanmam\u0131\u015F.",
  NO_ACTIVE_PACKAGE: "Aktif paketiniz bulunmuyor.",
  PACKAGE_EXPIRED: "Paketinizin s\xFCresi doldu. Yenilemek i\xE7in merkezle ileti\u015Fime ge\xE7in.",
  PAYMENT_NOT_VERIFIED: "\xD6deme do\u011Frulanmadan hesap etkinle\u015Ftirilemez.",
  NOT_FOUND: "Kay\u0131t bulunamad\u0131.",
  VALIDATION_FAILED: "L\xFCtfen alanlar\u0131 kontrol edin.",
  DUPLICATE_EMAIL: "Bu e-posta adresiyle kay\u0131tl\u0131 bir hesap zaten var.",
  DUPLICATE_RESOURCE: "Bu kay\u0131t zaten mevcut.",
  CONFLICT: "Kay\u0131t bu s\u0131rada de\u011Fi\u015Fmi\u015F. Sayfay\u0131 yenileyip tekrar deneyin.",
  APPOINTMENT_CONFLICT: "Se\xE7ilen saatte ba\u015Fka bir g\xF6r\xFC\u015Fme var.",
  PLAN_INCOMPLETE: "Plan yay\u0131nlanmadan \xF6nce eksik alanlar\u0131 tamamlay\u0131n.",
  PLAN_NOT_PUBLISHED: "Bu plan hen\xFCz yay\u0131nlanmad\u0131.",
  FILE_TOO_LARGE: "Dosya boyutu \xE7ok b\xFCy\xFCk.",
  UNSUPPORTED_FILE_TYPE: "Bu dosya t\xFCr\xFC desteklenmiyor.",
  UPLOAD_FAILED: "Y\xFCkleme tamamlanamad\u0131. Tekrar deneyin.",
  DAILY_PHOTO_LIMIT: "Bug\xFCn i\xE7in foto\u011Fraf s\u0131n\u0131r\u0131na ula\u015Ft\u0131n\u0131z.",
  CALL_ALREADY_ACTIVE: "Devam eden bir g\xF6r\xFC\u015Fme var.",
  CALL_NOT_AVAILABLE: "G\xF6r\xFC\u015Fme \u015Fu anda ba\u015Flat\u0131lam\u0131yor.",
  PEER_OFFLINE: "Kar\u015F\u0131 taraf \u015Fu anda \xE7evrimi\xE7i de\u011Fil.",
  RATE_LIMITED: "\xC7ok fazla istek g\xF6nderildi. L\xFCtfen biraz bekleyin.",
  INTERNAL_ERROR: "Beklenmeyen bir hata olu\u015Ftu.",
  SERVICE_UNAVAILABLE: "Servise \u015Fu anda ula\u015F\u0131lam\u0131yor.",
  NETWORK_ERROR: "Ba\u011Flant\u0131 kurulamad\u0131. \u0130nternetinizi kontrol edin."
};
var ERROR_MESSAGES_EN = {
  INVALID_CREDENTIALS: "Email or password is incorrect.",
  ACCOUNT_LOCKED: "Too many failed attempts. Please try again later.",
  ACCOUNT_NOT_ACTIVATED: "Your account is not activated yet. Use your invitation link.",
  ACCOUNT_SUSPENDED: "Your access has been paused. Please contact the clinic.",
  TOKEN_EXPIRED: "Your session has expired. Please sign in again.",
  TOKEN_INVALID: "This link is not valid.",
  INVITATION_EXPIRED: "Your invitation has expired. Please request a new one.",
  INVITATION_ALREADY_USED: "This invitation has already been used.",
  CONSENT_REQUIRED: "You need to accept the required consents to continue.",
  UNAUTHORIZED: "Please sign in to continue.",
  FORBIDDEN: "You do not have permission for this action.",
  NOT_ASSIGNED_TO_CLIENT: "This client is not assigned to you.",
  NO_ACTIVE_PACKAGE: "You do not have an active package.",
  PACKAGE_EXPIRED: "Your package has expired. Contact the clinic to renew.",
  PAYMENT_NOT_VERIFIED: "The account cannot be activated before the payment is verified.",
  NOT_FOUND: "Record not found.",
  VALIDATION_FAILED: "Please check the fields.",
  DUPLICATE_EMAIL: "An account with this email already exists.",
  DUPLICATE_RESOURCE: "This record already exists.",
  CONFLICT: "The record changed meanwhile. Refresh and try again.",
  APPOINTMENT_CONFLICT: "Another appointment exists at this time.",
  PLAN_INCOMPLETE: "Complete the missing fields before publishing.",
  PLAN_NOT_PUBLISHED: "This plan is not published yet.",
  FILE_TOO_LARGE: "The file is too large.",
  UNSUPPORTED_FILE_TYPE: "This file type is not supported.",
  UPLOAD_FAILED: "Upload could not be completed. Try again.",
  DAILY_PHOTO_LIMIT: "You reached the daily photo limit.",
  CALL_ALREADY_ACTIVE: "A call is already in progress.",
  CALL_NOT_AVAILABLE: "The call cannot be started right now.",
  PEER_OFFLINE: "The other person is offline.",
  RATE_LIMITED: "Too many requests. Please wait a moment.",
  INTERNAL_ERROR: "Something went wrong.",
  SERVICE_UNAVAILABLE: "The service is unavailable right now.",
  NETWORK_ERROR: "No connection. Check your internet."
};
var ERROR_STATUS = {
  INVALID_CREDENTIALS: 401,
  ACCOUNT_LOCKED: 429,
  ACCOUNT_NOT_ACTIVATED: 403,
  ACCOUNT_SUSPENDED: 403,
  TOKEN_EXPIRED: 401,
  TOKEN_INVALID: 401,
  INVITATION_EXPIRED: 410,
  INVITATION_ALREADY_USED: 409,
  CONSENT_REQUIRED: 403,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_ASSIGNED_TO_CLIENT: 403,
  NO_ACTIVE_PACKAGE: 403,
  PACKAGE_EXPIRED: 403,
  PAYMENT_NOT_VERIFIED: 409,
  NOT_FOUND: 404,
  VALIDATION_FAILED: 422,
  DUPLICATE_EMAIL: 409,
  DUPLICATE_RESOURCE: 409,
  CONFLICT: 409,
  APPOINTMENT_CONFLICT: 409,
  PLAN_INCOMPLETE: 422,
  PLAN_NOT_PUBLISHED: 409,
  FILE_TOO_LARGE: 413,
  UNSUPPORTED_FILE_TYPE: 415,
  UPLOAD_FAILED: 500,
  DAILY_PHOTO_LIMIT: 429,
  CALL_ALREADY_ACTIVE: 409,
  CALL_NOT_AVAILABLE: 409,
  PEER_OFFLINE: 409,
  RATE_LIMITED: 429,
  INTERNAL_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  NETWORK_ERROR: 503
};
function errorMessage(code, locale = "tr") {
  const table = locale === "en" ? ERROR_MESSAGES_EN : ERROR_MESSAGES_TR;
  return table[code] ?? table.INTERNAL_ERROR;
}

// src/routes.ts
var API_PREFIX = "/api/v1";
var ROUTES = {
  health: "/health",
  auth: {
    login: "/auth/login",
    refresh: "/auth/refresh",
    logout: "/auth/logout",
    me: "/auth/me",
    invitationPreview: (token) => `/auth/invitation/${token}`,
    activate: "/auth/activate",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password",
    changePassword: "/auth/change-password",
    pushToken: "/auth/push-token",
    consents: "/auth/consents"
  },
  profile: {
    me: "/profile",
    avatar: "/profile/avatar",
    notificationPreferences: "/profile/notification-preferences",
    dataRequests: "/profile/data-requests",
    export: "/profile/export"
  },
  clients: {
    list: "/clients",
    create: "/clients",
    detail: (id) => `/clients/${id}`,
    update: (id) => `/clients/${id}`,
    setStatus: (id) => `/clients/${id}/status`,
    resendInvitation: (id) => `/clients/${id}/resend-invitation`,
    assignDietitian: (id) => `/clients/${id}/dietitian`,
    internalNotes: (id) => `/clients/${id}/internal-notes`,
    timeline: (id) => `/clients/${id}/timeline`
  },
  packages: {
    list: "/packages",
    create: "/packages",
    detail: (id) => `/packages/${id}`,
    activate: (id) => `/packages/${id}/activate`,
    renew: (id) => `/packages/${id}/renew`,
    cancel: (id) => `/packages/${id}/cancel`,
    verifyPayment: "/packages/verify-payment",
    expiring: "/packages/expiring"
  },
  /** Besin değişim listesi kütüphanesi — gruplar, kalemler, kurallar. */
  exchange: {
    library: "/exchange/library",
    items: "/exchange/items",
    item: (id) => `/exchange/items/${id}`,
    dishes: "/exchange/dishes",
    dish: (id) => `/exchange/dishes/${id}`,
    rules: "/exchange/rules",
    rule: (id) => `/exchange/rules/${id}`,
    /** Danışanın kendi reçetesi ve günlük porsiyon karnesi. */
    myPrescription: "/me/exchange/prescription",
    myTally: "/me/exchange/tally",
    myLog: "/me/exchange/log"
  },
  plans: {
    list: "/plans",
    create: "/plans",
    detail: (id) => `/plans/${id}`,
    update: (id) => `/plans/${id}`,
    publish: (id) => `/plans/${id}/publish`,
    archive: (id) => `/plans/${id}/archive`,
    duplicate: (id) => `/plans/${id}/duplicate`,
    versions: (id) => `/plans/${id}/versions`,
    /** Plandaki besin değişim reçetesi. */
    prescription: (id) => `/plans/${id}/prescription`,
    /** Onay zinciri: hazırlayan → kontrol eden → onaylayan. */
    check: (id) => `/plans/${id}/check`,
    approve: (id) => `/plans/${id}/approve`,
    /** Danışanın belirli bir günü — mobil plan ekranı. */
    myDay: "/me/plan/day",
    myWeek: "/me/plan/week",
    myHistory: "/me/plan/history",
    myHistoryDay: "/me/plan/history/day"
  },
  templates: {
    list: "/templates",
    create: "/templates",
    detail: (id) => `/templates/${id}`,
    update: (id) => `/templates/${id}`,
    delete: (id) => `/templates/${id}`,
    apply: "/templates/apply",
    library: "/templates/meal-library",
    libraryCreate: "/templates/meal-library",
    libraryDetail: (id) => `/templates/meal-library/${id}`
  },
  recipes: {
    list: "/recipes",
    create: "/recipes",
    detail: (id) => `/recipes/${id}`,
    update: (id) => `/recipes/${id}`
  },
  tracking: {
    today: "/me/today",
    mealLog: "/me/meal-logs",
    water: "/me/water",
    wellbeing: "/me/wellbeing",
    steps: "/me/steps",
    streak: "/me/streak",
    badges: "/me/badges",
    shoppingList: "/me/shopping-list",
    shoppingListGenerate: "/me/shopping-list/generate",
    shoppingItem: (id) => `/me/shopping-list/items/${id}`,
    progress: "/me/progress"
  },
  photos: {
    presign: "/uploads/presign",
    create: "/meal-photos",
    list: "/meal-photos",
    detail: (id) => `/meal-photos/${id}`,
    feedback: (id) => `/meal-photos/${id}/feedback`,
    analyze: (id) => `/meal-photos/${id}/analyze`,
    queue: "/meal-photos/queue"
  },
  measurements: {
    list: "/measurements",
    create: "/measurements",
    detail: (id) => `/measurements/${id}`,
    update: (id) => `/measurements/${id}`,
    delete: (id) => `/measurements/${id}`,
    publish: (id) => `/measurements/${id}/publish`,
    due: "/measurements/due"
  },
  messages: {
    conversations: "/conversations",
    conversationDetail: (id) => `/conversations/${id}`,
    messages: (id) => `/conversations/${id}/messages`,
    send: (id) => `/conversations/${id}/messages`,
    markRead: (id) => `/conversations/${id}/read`,
    myConversation: "/me/conversation",
    questions: "/questions",
    questionDetail: (id) => `/questions/${id}`,
    broadcast: "/messages/broadcast"
  },
  calls: {
    start: "/calls",
    detail: (id) => `/calls/${id}`,
    end: (id) => `/calls/${id}/end`,
    history: "/calls",
    iceServers: "/calls/ice-servers"
  },
  appointments: {
    list: "/appointments",
    create: "/appointments",
    detail: (id) => `/appointments/${id}`,
    update: (id) => `/appointments/${id}`,
    cancel: (id) => `/appointments/${id}/cancel`,
    availability: "/appointments/availability",
    requestReschedule: (id) => `/appointments/${id}/request-reschedule`,
    myList: "/me/appointments"
  },
  notifications: {
    list: "/notifications",
    markRead: (id) => `/notifications/${id}/read`,
    markAllRead: "/notifications/read-all",
    unreadCount: "/notifications/unread-count",
    rules: "/notification-rules",
    rule: (id) => `/notification-rules/${id}`,
    deliveries: "/notification-rules/deliveries"
  },
  admin: {
    dashboard: "/admin/dashboard",
    report: "/admin/reports",
    reportExport: "/admin/reports/export",
    weeklyReport: "/admin/reports/weekly",
    team: "/admin/team",
    teamMember: (id) => `/admin/team/${id}`,
    teamInvite: "/admin/team/invite",
    assignClients: "/admin/team/assign",
    audit: "/admin/audit",
    dataRequests: "/admin/data-requests",
    dataRequest: (id) => `/admin/data-requests/${id}`,
    settings: "/admin/settings"
  },
  files: {
    /** Yerel depolamada dosya sunumu (üretimde S3 imzalı URL). */
    serve: (key) => `/files/${key}`
  }
};
var DEEP_LINK_SCHEME = "foreverdeluxe";
var deepLink = {
  today: () => `${DEEP_LINK_SCHEME}://today`,
  plan: (date) => `${DEEP_LINK_SCHEME}://plan${date ? `?date=${date}` : ""}`,
  meal: (planMealId, date) => `${DEEP_LINK_SCHEME}://plan/meal/${planMealId}?date=${date}`,
  messages: () => `${DEEP_LINK_SCHEME}://messages`,
  message: (messageId) => `${DEEP_LINK_SCHEME}://messages?highlight=${messageId}`,
  call: (callId) => `${DEEP_LINK_SCHEME}://call/${callId}`,
  progress: () => `${DEEP_LINK_SCHEME}://progress`,
  calendar: (appointmentId) => `${DEEP_LINK_SCHEME}://calendar${appointmentId ? `?appointment=${appointmentId}` : ""}`,
  notifications: () => `${DEEP_LINK_SCHEME}://notifications`,
  profile: () => `${DEEP_LINK_SCHEME}://profile`,
  photo: (photoId) => `${DEEP_LINK_SCHEME}://photos/${photoId}`,
  shoppingList: () => `${DEEP_LINK_SCHEME}://shopping-list`
};
var adminPath = {
  dashboard: "/",
  clients: "/danisanlar",
  client: (id) => `/danisanlar/${id}`,
  clientTab: (id, tab) => `/danisanlar/${id}?sekme=${tab}`,
  newClient: "/danisanlar/yeni",
  packages: "/paketler",
  package: (id) => `/paketler/${id}`,
  plans: "/planlar",
  exchangeLibrary: "/degisim-listesi",
  planEditor: (id) => `/planlar/${id}`,
  newPlan: "/planlar/yeni",
  templates: "/sablonlar",
  messages: "/mesajlar",
  conversation: (id) => `/mesajlar/${id}`,
  questions: "/bekleyen-sorular",
  photos: "/ogun-fotograflari",
  photo: (id) => `/ogun-fotograflari/${id}`,
  measurements: "/olcumler",
  clientMeasurements: (clientId) => `/olcumler?danisan=${clientId}`,
  calendar: "/takvim",
  appointment: (id) => `/takvim/${id}`,
  notificationRules: "/bildirimler",
  reports: "/raporlar",
  team: "/ekip",
  settings: "/ayarlar",
  audit: "/islem-gecmisi"
};

// src/utils.ts
function toDateOnly(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
function fromDateOnly(s) {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d, 0, 0, 0, 0);
}
function addDays(date, days) {
  const next = new Date(date.getTime());
  next.setDate(next.getDate() + days);
  return next;
}
function isoDayOfWeek(date) {
  const day = date.getDay();
  return day === 0 ? 7 : day;
}
function startOfWeek(date) {
  const d = new Date(date.getTime());
  d.setHours(0, 0, 0, 0);
  return addDays(d, -(isoDayOfWeek(d) - 1));
}
function endOfWeek(date) {
  return addDays(startOfWeek(date), 6);
}
function daysBetween(a, b) {
  const ms = fromDateOnly(toDateOnly(b)).getTime() - fromDateOnly(toDateOnly(a)).getTime();
  return Math.round(ms / 864e5);
}
function isSameDay(a, b) {
  return toDateOnly(a) === toDateOnly(b);
}
function timeToMinutes(time) {
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
}
function minutesToTime(total) {
  const clamped = (total % 1440 + 1440) % 1440;
  const h = Math.floor(clamped / 60);
  const m = clamped % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}
function overlaps(aStart, aEnd, bStart, bEnd) {
  return aStart < bEnd && bStart < aEnd;
}
var TR_MONTHS = [
  "Ocak",
  "\u015Eubat",
  "Mart",
  "Nisan",
  "May\u0131s",
  "Haziran",
  "Temmuz",
  "A\u011Fustos",
  "Eyl\xFCl",
  "Ekim",
  "Kas\u0131m",
  "Aral\u0131k"
];
var TR_DAYS_SHORT = ["Pt", "Sa", "\xC7a", "Pe", "Cu", "Ct", "Pz"];
var TR_DAYS_LONG = ["Pazartesi", "Sal\u0131", "\xC7ar\u015Famba", "Per\u015Fembe", "Cuma", "Cumartesi", "Pazar"];
function trMonthName(monthIndex) {
  return TR_MONTHS[monthIndex] ?? "";
}
function trDayShort(isoDay) {
  return TR_DAYS_SHORT[isoDay - 1] ?? "";
}
function trDayLong(isoDay) {
  return TR_DAYS_LONG[isoDay - 1] ?? "";
}
function formatDateTr(date, withYear = false) {
  const base = `${date.getDate()} ${trMonthName(date.getMonth())}`;
  return withYear ? `${base} ${date.getFullYear()}` : base;
}
function formatDateRangeTr(start, end) {
  const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
  if (sameMonth) {
    return `${String(start.getDate()).padStart(2, "0")} - ${String(end.getDate()).padStart(2, "0")} ${trMonthName(start.getMonth())}`;
  }
  return `${formatDateTr(start)} - ${formatDateTr(end)}`;
}
function formatTime(date) {
  return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
}
function formatDurationTr(minutes) {
  if (minutes < 1) return "az \xF6nce";
  if (minutes < 60) return `${Math.floor(minutes)} dk`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    const rem = Math.floor(minutes % 60);
    return rem > 0 ? `${hours} sa ${rem} dk` : `${hours} sa`;
  }
  const days = Math.floor(hours / 24);
  return `${days} g\xFCn`;
}
function formatCallDuration(seconds) {
  const s = Math.max(0, Math.floor(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor(s % 3600 / 60);
  const sec = s % 60;
  const mm = String(m).padStart(2, "0");
  const ss = String(sec).padStart(2, "0");
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
function formatNumberTr(value, decimals = 1) {
  if (!Number.isFinite(value)) return "\u2014";
  const factor = 10 ** decimals;
  const rounded = Math.round(Math.abs(value) * factor + Number.EPSILON * factor) / factor;
  const signed = value < 0 ? -rounded : rounded;
  return signed.toFixed(decimals).replace(".", ",");
}
function formatWeightTr(kg) {
  if (kg == null) return "\u2014";
  return `${formatNumberTr(kg, 1)} kg`;
}
function formatDeltaTr(value, unit = "kg") {
  if (value == null) return "\u2014";
  const sign = value > 0 ? "+" : value < 0 ? "\u2212" : "";
  return `${sign}${formatNumberTr(Math.abs(value), 1)} ${unit}`;
}
function formatCurrencyTr(amount, currency = "TRY") {
  const formatted = new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency,
    minimumFractionDigits: 2
  }).format(amount);
  return formatted;
}
function initials(fullName) {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0];
  const last = parts.length > 1 ? parts[parts.length - 1] : "";
  return (upperTr(first[0] ?? "") + upperTr(last[0] ?? "")).slice(0, 2);
}
function upperTr(s) {
  return s.replace(/i/g, "\u0130").replace(/ı/g, "I").toUpperCase();
}
function lowerTr(s) {
  return s.replace(/I/g, "\u0131").replace(/İ/g, "i").toLowerCase();
}
function mealSlotLabel(slot, locale = "tr") {
  return locale === "en" ? MEAL_SLOT_LABELS_EN[slot] : MEAL_SLOT_LABELS_TR[slot];
}
function sortBySlot(meals) {
  return [...meals].sort(
    (a, b) => MEAL_SLOT_ORDER.indexOf(a.slot) - MEAL_SLOT_ORDER.indexOf(b.slot)
  );
}
function calculateBmi(weightKg, heightCm) {
  if (!weightKg || !heightCm) return null;
  const m = heightCm / 100;
  const bmi = weightKg / (m * m);
  return Math.round(bmi * 10) / 10;
}
function bmiCategory(bmi) {
  if (bmi < 18.5) return "UNDERWEIGHT";
  if (bmi < 25) return "NORMAL";
  if (bmi < 30) return "OVERWEIGHT";
  return "OBESE";
}
var BMI_CATEGORY_LABELS_TR = {
  UNDERWEIGHT: "Zay\u0131f",
  NORMAL: "Normal",
  OVERWEIGHT: "Fazla kilolu",
  OBESE: "Obez"
};
function goalProgress(start, current, target) {
  if (start == null || current == null || target == null) return null;
  const span = target - start;
  if (Math.abs(span) < 1e-3) return current === target ? 1 : null;
  const done = (current - start) / span;
  return Math.max(0, Math.min(1, done));
}
function adherenceRate(completed, total) {
  if (total <= 0) return 0;
  return Math.max(0, Math.min(1, completed / total));
}
function hydrationRatio(totalMl, goalMl) {
  if (goalMl <= 0) return 0;
  return Math.max(0, Math.min(1, totalMl / goalMl));
}
function calculateBmr(weightKg, heightCm, age, gender) {
  const base = 10 * weightKg + 6.25 * heightCm - 5 * age;
  return Math.round(gender === "MALE" ? base + 5 : base - 161);
}
var ACTIVITY_FACTORS = {
  SEDENTARY: 1.2,
  LIGHT: 1.375,
  MODERATE: 1.55,
  ACTIVE: 1.725,
  VERY_ACTIVE: 1.9
};
function calculateTdee(bmr, activityLevel) {
  return Math.round(bmr * (ACTIVITY_FACTORS[activityLevel] ?? 1.2));
}
function ageFromBirthDate(birthDate, now = /* @__PURE__ */ new Date()) {
  const d = typeof birthDate === "string" ? fromDateOnly(birthDate.slice(0, 10)) : birthDate;
  if (Number.isNaN(d.getTime())) return null;
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || m === 0 && now.getDate() < d.getDate()) age -= 1;
  return age;
}
function truncate(text, max = 80) {
  const clean = text.replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max);
  const lastSpace = cut.lastIndexOf(" ");
  return `${(lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut).trimEnd()}\u2026`;
}
function randomId(length = 21) {
  const alphabet = "useandom26T198340PX75pxJACKVERYMINDBUSHWOLFGQZbfghjklqvwyzrict";
  let out = "";
  const bytes = new Uint8Array(length);
  if (typeof globalThis.crypto?.getRandomValues === "function") {
    globalThis.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  for (let i = 0; i < length; i += 1) {
    out += alphabet[bytes[i] % alphabet.length];
  }
  return out;
}
function clientMessageKey(prefix) {
  return `${prefix}_${randomId(16)}`;
}
function groupBy(items, keyOf) {
  const out = {};
  for (const item of items) {
    const k = keyOf(item);
    (out[k] ??= []).push(item);
  }
  return out;
}
function unique(items) {
  return Array.from(new Set(items));
}
function nullifyEmpty(value) {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

// src/schemas/common.ts
import { z } from "zod";
var zId = z.string().min(8).max(64);
var zDateOnly = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Tarih YYYY-AA-GG bi\xE7iminde olmal\u0131");
var zDateTime = z.string().datetime({ offset: true });
var zTime = z.string().regex(/^([01]\d|2[0-3]):([0-5]\d)$/, "Saat SS:DD bi\xE7iminde olmal\u0131");
var zEmail = z.string().trim().toLowerCase().email("Ge\xE7erli bir e-posta adresi girin").max(254);
var zPhone = z.string().trim().regex(/^(\+90|0)?5\d{9}$/, "Ge\xE7erli bir cep telefonu girin").transform((v) => v.startsWith("+90") ? v : `+90${v.replace(/^0/, "")}`);
var zPassword = z.string().min(RULES.minPasswordLength, `\u015Eifre en az ${RULES.minPasswordLength} karakter olmal\u0131`).max(128).refine((v) => /[a-zçğıöşü]/.test(v), "\u015Eifre en az bir k\xFC\xE7\xFCk harf i\xE7ermeli").refine((v) => /[A-ZÇĞİÖŞÜ]/.test(v), "\u015Eifre en az bir b\xFCy\xFCk harf i\xE7ermeli").refine((v) => /\d/.test(v), "\u015Eifre en az bir rakam i\xE7ermeli");
var zPagination = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(RULES.maxPageSize).default(RULES.defaultPageSize)
});
function paginated(item) {
  return z.object({
    items: z.array(item),
    page: z.number().int(),
    pageSize: z.number().int(),
    total: z.number().int(),
    totalPages: z.number().int()
  });
}
var zApiError = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    /** Alan bazlı doğrulama hataları — formlar doğrudan bağlar. */
    fields: z.record(z.string(), z.string()).optional(),
    requestId: z.string().optional()
  })
});
var zSortOrder = z.enum(["asc", "desc"]).default("desc");
var zStoredFile = z.object({
  key: z.string(),
  url: z.string(),
  thumbnailUrl: z.string().nullable(),
  mimeType: z.string(),
  sizeBytes: z.number().int(),
  width: z.number().int().nullable(),
  height: z.number().int().nullable()
});
var zMacros = z.object({
  calories: z.number().min(0).max(1e4).nullable().optional(),
  proteinG: z.number().min(0).max(1e3).nullable().optional(),
  carbsG: z.number().min(0).max(1e3).nullable().optional(),
  fatG: z.number().min(0).max(1e3).nullable().optional(),
  fiberG: z.number().min(0).max(300).nullable().optional()
});

// src/schemas/auth.ts
import { z as z2 } from "zod";
var zLoginInput = z2.object({
  email: zEmail,
  password: z2.string().min(1, "\u015Eifre gerekli"),
  /** Cihazı hatırla — yenileme jetonu ömrünü uzatır. */
  rememberDevice: z2.boolean().optional().default(false),
  deviceName: z2.string().max(80).optional()
});
var zSessionUser = z2.object({
  id: zId,
  email: z2.string(),
  fullName: z2.string(),
  role: z2.nativeEnum(UserRole),
  status: z2.nativeEnum(UserStatus),
  avatarUrl: z2.string().nullable(),
  locale: z2.nativeEnum(Locale),
  /** Danışan ise bağlı olduğu diyetisyen. */
  dietitianId: zId.nullable(),
  /** Danışanın aktif paketi var mı — mobil kapı kontrolü. */
  hasActivePackage: z2.boolean(),
  /** Alınması gereken açık rızalar; boş değilse uygulama onay ekranını açar. */
  pendingConsents: z2.array(z2.nativeEnum(ConsentType)),
  permissions: z2.array(z2.string())
});
var zAuthTokens = z2.object({
  accessToken: z2.string(),
  refreshToken: z2.string(),
  /** Erişim jetonunun sona erme anı (ISO). */
  expiresAt: z2.string()
});
var zLoginResponse = z2.object({
  user: zSessionUser,
  tokens: zAuthTokens
});
var zRefreshInput = z2.object({ refreshToken: z2.string().min(10) });
var zActivateAccountInput = z2.object({
  token: z2.string().min(16),
  password: zPassword,
  /** KVKK açık rızaları — sağlık verisi işlenebilmesi için zorunlu. */
  consents: z2.array(
    z2.object({
      type: z2.nativeEnum(ConsentType),
      accepted: z2.boolean(),
      version: z2.string()
    })
  ).min(1)
});
var zInvitationPreview = z2.object({
  valid: z2.boolean(),
  expired: z2.boolean(),
  fullName: z2.string().nullable(),
  email: z2.string().nullable(),
  /** Gerekli rıza metinlerinin güncel sürümleri. */
  requiredConsents: z2.array(z2.object({ type: z2.nativeEnum(ConsentType), version: z2.string() }))
});
var zForgotPasswordInput = z2.object({ email: zEmail });
var zResetPasswordInput = z2.object({
  token: z2.string().min(16),
  password: zPassword
});
var zChangePasswordInput = z2.object({
  currentPassword: z2.string().min(1),
  newPassword: zPassword
}).refine((v) => v.currentPassword !== v.newPassword, {
  message: "Yeni \u015Fifre eskisiyle ayn\u0131 olamaz",
  path: ["newPassword"]
});
var zRegisterPushTokenInput = z2.object({
  token: z2.string().min(10),
  platform: z2.enum(["ios", "android", "web"]),
  deviceId: z2.string().max(128).optional(),
  appVersion: z2.string().max(32).optional()
});
var zUpdateProfileInput = z2.object({
  fullName: z2.string().trim().min(2).max(120).optional(),
  phone: zPhone.optional(),
  locale: z2.nativeEnum(Locale).optional(),
  avatarKey: z2.string().max(256).nullable().optional(),
  /** Cihaz saat dilimi — hatırlatmaların doğru saatte gitmesi için. */
  timezone: z2.string().max(64).optional()
});
var zNotificationPreferences = z2.object({
  pushEnabled: z2.boolean(),
  mealReminders: z2.boolean(),
  waterReminders: z2.boolean(),
  appointmentReminders: z2.boolean(),
  messageAlerts: z2.boolean(),
  weeklyReport: z2.boolean(),
  /** Rahatsız etme aralığı. */
  quietHoursStart: z2.string().nullable(),
  quietHoursEnd: z2.string().nullable()
});
var zConsentRecord = z2.object({
  type: z2.nativeEnum(ConsentType),
  version: z2.string(),
  acceptedAt: z2.string().nullable(),
  revokedAt: z2.string().nullable()
});
var zGiveConsentInput = z2.object({
  type: z2.nativeEnum(ConsentType),
  version: z2.string(),
  accepted: z2.boolean()
});

// src/schemas/client.ts
import { z as z3 } from "zod";
var zClientListItem = z3.object({
  id: zId,
  userId: zId,
  fullName: z3.string(),
  email: z3.string(),
  phone: z3.string().nullable(),
  avatarUrl: z3.string().nullable(),
  serviceType: z3.nativeEnum(ServiceType),
  status: z3.nativeEnum(UserStatus),
  packageStatus: z3.nativeEnum(PackageStatus).nullable(),
  packageEndsAt: z3.string().nullable(),
  dietitianId: zId.nullable(),
  dietitianName: z3.string().nullable(),
  lastActivityAt: z3.string().nullable(),
  /** Diyetisyenin iş listesi için hızlı göstergeler. */
  openQuestionCount: z3.number().int(),
  pendingPhotoCount: z3.number().int(),
  measurementDue: z3.boolean()
});
var zClientListQuery = zPagination.extend({
  q: z3.string().trim().max(120).optional(),
  serviceType: z3.nativeEnum(ServiceType).optional(),
  status: z3.nativeEnum(UserStatus).optional(),
  packageStatus: z3.nativeEnum(PackageStatus).optional(),
  dietitianId: zId.optional(),
  /** "Sadece bana atananlar" kısayolu. */
  assignedToMe: z3.coerce.boolean().optional(),
  sortBy: z3.enum(["name", "lastActivity", "packageEnd", "createdAt"]).default("lastActivity"),
  sortOrder: z3.enum(["asc", "desc"]).default("desc")
});
var zCreateClientInput = z3.object({
  fullName: z3.string().trim().min(2, "Ad soyad gerekli").max(120),
  email: zEmail,
  phone: zPhone.optional(),
  serviceType: z3.nativeEnum(ServiceType),
  dietitianId: zId.optional(),
  birthDate: zDateOnly.optional(),
  gender: z3.enum(["FEMALE", "MALE", "OTHER", "UNSPECIFIED"]).optional(),
  heightCm: z3.number().min(80).max(250).optional(),
  startWeightKg: z3.number().min(25).max(400).optional(),
  targetWeightKg: z3.number().min(25).max(400).optional(),
  goal: z3.nativeEnum(ClientGoal).optional(),
  activityLevel: z3.nativeEnum(ActivityLevel).optional(),
  dietaryPreferences: z3.array(z3.nativeEnum(DietaryPreference)).default([]),
  allergies: z3.array(z3.string().max(80)).default([]),
  healthNotes: z3.string().max(4e3).optional(),
  /** Paket bilgisi aynı adımda girilirse hesap doğrudan hazırlanır. */
  package: z3.object({
    title: z3.string().max(120).optional(),
    startDate: zDateOnly,
    endDate: zDateOnly,
    priceAmount: z3.number().min(0).max(1e6),
    currency: z3.string().length(3).default("TRY"),
    paymentMethod: z3.nativeEnum(PaymentMethod),
    paymentReference: z3.string().max(120).optional(),
    paidAt: zDateOnly.optional()
  }).optional(),
  /** Hesap oluşturulur oluşturulmaz davet gönderilsin mi. */
  sendInvitation: z3.boolean().default(true)
});
var zUpdateClientInput = zCreateClientInput.omit({ email: true, package: true, sendInvitation: true }).partial().extend({
  /** Yalnızca ekip görür, danışana asla gösterilmez. */
  internalNotes: z3.string().max(8e3).optional(),
  medications: z3.array(z3.string().max(120)).optional(),
  dailyWaterGoalMl: z3.number().int().min(500).max(8e3).optional()
});
var zClientDetail = z3.object({
  id: zId,
  userId: zId,
  fullName: z3.string(),
  email: z3.string(),
  phone: z3.string().nullable(),
  avatarUrl: z3.string().nullable(),
  status: z3.nativeEnum(UserStatus),
  serviceType: z3.nativeEnum(ServiceType),
  dietitianId: zId.nullable(),
  dietitianName: z3.string().nullable(),
  birthDate: z3.string().nullable(),
  gender: z3.string().nullable(),
  heightCm: z3.number().nullable(),
  startWeightKg: z3.number().nullable(),
  targetWeightKg: z3.number().nullable(),
  latestWeightKg: z3.number().nullable(),
  goal: z3.nativeEnum(ClientGoal).nullable(),
  activityLevel: z3.nativeEnum(ActivityLevel).nullable(),
  dietaryPreferences: z3.array(z3.nativeEnum(DietaryPreference)),
  allergies: z3.array(z3.string()),
  medications: z3.array(z3.string()),
  healthNotes: z3.string().nullable(),
  /** Sadece ADMIN/DIETITIAN yanıtlarında dolu gelir. */
  internalNotes: z3.string().nullable(),
  dailyWaterGoalMl: z3.number().int(),
  createdAt: z3.string(),
  activePackage: z3.object({
    id: zId,
    title: z3.string(),
    serviceType: z3.nativeEnum(ServiceType),
    status: z3.nativeEnum(PackageStatus),
    startDate: z3.string(),
    endDate: z3.string(),
    daysRemaining: z3.number().int()
  }).nullable(),
  /** Takip özeti kartı. */
  summary: z3.object({
    todayCompletedMeals: z3.number().int(),
    todayTotalMeals: z3.number().int(),
    currentStreakDays: z3.number().int(),
    lastMeasurementAt: z3.string().nullable(),
    nextAppointmentAt: z3.string().nullable(),
    openQuestionCount: z3.number().int(),
    pendingPhotoCount: z3.number().int(),
    unreadMessageCount: z3.number().int(),
    adherenceRate7d: z3.number().min(0).max(1)
  })
});
var zServicePackage = z3.object({
  id: zId,
  clientId: zId,
  clientName: z3.string().optional(),
  title: z3.string(),
  serviceType: z3.nativeEnum(ServiceType),
  status: z3.nativeEnum(PackageStatus),
  startDate: z3.string(),
  endDate: z3.string(),
  daysRemaining: z3.number().int(),
  priceAmount: z3.number(),
  currency: z3.string(),
  notes: z3.string().nullable(),
  payment: z3.object({
    id: zId,
    amount: z3.number(),
    currency: z3.string(),
    method: z3.nativeEnum(PaymentMethod),
    status: z3.nativeEnum(PaymentStatus),
    paidAt: z3.string().nullable(),
    reference: z3.string().nullable(),
    verifiedAt: z3.string().nullable(),
    verifiedByName: z3.string().nullable(),
    note: z3.string().nullable()
  }).nullable(),
  createdAt: z3.string()
});
var zCreatePackageInput = z3.object({
  clientId: zId,
  title: z3.string().trim().min(2).max(120),
  serviceType: z3.nativeEnum(ServiceType),
  startDate: zDateOnly,
  endDate: zDateOnly,
  priceAmount: z3.number().min(0).max(1e6),
  currency: z3.string().length(3).default("TRY"),
  notes: z3.string().max(2e3).optional(),
  payment: z3.object({
    amount: z3.number().min(0),
    currency: z3.string().length(3).default("TRY"),
    method: z3.nativeEnum(PaymentMethod),
    paidAt: zDateOnly.optional(),
    reference: z3.string().max(120).optional(),
    note: z3.string().max(1e3).optional()
  })
});
var zVerifyPaymentInput = z3.object({
  paymentId: zId,
  status: z3.enum([PaymentStatus.VERIFIED, PaymentStatus.FAILED, PaymentStatus.REFUNDED]),
  note: z3.string().max(1e3).optional()
});
var zActivatePackageInput = z3.object({
  packageId: zId,
  /** Etkinleştirmeyle birlikte davet de gönderilsin mi. */
  sendInvitation: z3.boolean().default(true)
});
var zRenewPackageInput = z3.object({
  packageId: zId,
  startDate: zDateOnly,
  endDate: zDateOnly,
  priceAmount: z3.number().min(0),
  currency: z3.string().length(3).default("TRY"),
  paymentMethod: z3.nativeEnum(PaymentMethod),
  paymentReference: z3.string().max(120).optional()
});

// src/schemas/plan.ts
import { z as z4 } from "zod";
var zMealItem = z4.object({
  id: zId.optional(),
  name: z4.string().trim().min(1).max(160),
  quantity: z4.number().min(0).max(1e4).nullable().optional(),
  unit: z4.string().max(24).nullable().optional(),
  groceryCategory: z4.enum(GROCERY_CATEGORIES).nullable().optional(),
  order: z4.number().int().min(0).default(0)
});
var zMealAlternative = z4.object({
  id: zId.optional(),
  title: z4.string().trim().min(1).max(200),
  description: z4.string().max(1e3).nullable().optional(),
  portion: z4.string().max(120).nullable().optional(),
  order: z4.number().int().min(0).default(0)
});
var zPlanMeal = z4.object({
  id: zId.optional(),
  slot: z4.nativeEnum(MealSlot),
  time: zTime,
  title: z4.string().trim().min(1, "\xD6\u011F\xFCn ba\u015Fl\u0131\u011F\u0131 gerekli").max(200),
  description: z4.string().max(2e3).nullable().optional(),
  portion: z4.string().max(160).nullable().optional(),
  /** Diyetisyenin danışana görünen notu. */
  note: z4.string().max(1e3).nullable().optional(),
  macros: zMacros.nullable().optional(),
  items: z4.array(zMealItem).default([]),
  alternatives: z4.array(zMealAlternative).default([]),
  recipeId: zId.nullable().optional(),
  order: z4.number().int().min(0).default(0)
});
var zPlanDay = z4.object({
  id: zId.optional(),
  /** 1 = Pazartesi … 7 = Pazar */
  dayOfWeek: z4.number().int().min(1).max(7),
  /** V2: tarih varsa yalnız o güne özel menü; yoksa haftalık tekrar. */
  date: zDateOnly.nullable().optional(),
  note: z4.string().max(1e3).nullable().optional(),
  meals: z4.array(zPlanMeal).default([])
});
var zDietPlan = z4.object({
  id: zId,
  clientId: zId,
  clientName: z4.string().optional(),
  dietitianId: zId,
  dietitianName: z4.string().optional(),
  title: z4.string(),
  status: z4.nativeEnum(PlanStatus),
  /** Aynı danışanın planı güncellendikçe sürüm artar; geçmiş korunur. */
  version: z4.number().int(),
  startDate: z4.string(),
  endDate: z4.string(),
  notes: z4.string().nullable(),
  publishedAt: z4.string().nullable(),
  createdAt: z4.string(),
  updatedAt: z4.string(),
  days: z4.array(zPlanDay),
  /** Toplam öğün sayısı — liste ekranlarında özet. */
  mealCount: z4.number().int().optional()
});
var zCreatePlanInput = z4.object({
  clientId: zId,
  title: z4.string().trim().min(2).max(160),
  startDate: zDateOnly,
  endDate: zDateOnly,
  notes: z4.string().max(4e3).optional(),
  days: z4.array(zPlanDay).default([]),
  /** Şablondan başlatılıyorsa kaynak. */
  templateId: zId.optional()
});
var zUpdatePlanInput = zCreatePlanInput.partial().omit({ clientId: true });
var zPublishPlanInput = z4.object({
  planId: zId,
  /** Danışana gidecek kısa duyuru notu. */
  announcement: z4.string().max(500).optional(),
  notifyClient: z4.boolean().default(true)
});
var zPlanListQuery = zPagination.extend({
  clientId: zId.optional(),
  status: z4.nativeEnum(PlanStatus).optional(),
  from: zDateOnly.optional(),
  to: zDateOnly.optional()
});
var zDayPlanView = z4.object({
  date: z4.string(),
  dayOfWeek: z4.number().int(),
  planId: zId.nullable(),
  planTitle: z4.string().nullable(),
  planVersion: z4.number().int().nullable(),
  /** Plan bu tarih için yayında değilse false; ekran hazırlık durumu gösterir. */
  hasPlan: z4.boolean(),
  dayNote: z4.string().nullable(),
  meals: z4.array(
    z4.object({
      planMealId: zId,
      slot: z4.nativeEnum(MealSlot),
      time: z4.string(),
      title: z4.string(),
      description: z4.string().nullable(),
      portion: z4.string().nullable(),
      note: z4.string().nullable(),
      macros: zMacros.nullable(),
      items: z4.array(zMealItem),
      alternatives: z4.array(zMealAlternative),
      recipeId: zId.nullable(),
      /** Danışanın kaydı. */
      logId: zId.nullable(),
      status: z4.enum(["PLANNED", "COMPLETED", "SKIPPED"]),
      completedAt: z4.string().nullable(),
      clientNote: z4.string().nullable(),
      photoCount: z4.number().int(),
      hasFeedback: z4.boolean()
    })
  ),
  completedCount: z4.number().int(),
  totalCount: z4.number().int()
});
var zPlanTemplate = z4.object({
  id: zId,
  name: z4.string(),
  description: z4.string().nullable(),
  tags: z4.array(z4.string()),
  dayCount: z4.number().int(),
  mealCount: z4.number().int(),
  ownerId: zId,
  ownerName: z4.string().nullable(),
  /** Ekipteki diğer diyetisyenler de kullanabilir mi. */
  isShared: z4.boolean(),
  archivedAt: z4.string().nullable(),
  createdAt: z4.string(),
  updatedAt: z4.string(),
  days: z4.array(zPlanDay).optional()
});
var zCreateTemplateInput = z4.object({
  name: z4.string().trim().min(2).max(160),
  description: z4.string().max(1e3).optional(),
  tags: z4.array(z4.string().max(40)).max(12).default([]),
  isShared: z4.boolean().default(false),
  days: z4.array(zPlanDay).default([]),
  /** Mevcut bir plandan şablon çıkarmak için. */
  fromPlanId: zId.optional()
});
var zApplyTemplateInput = z4.object({
  templateId: zId,
  clientId: zId,
  startDate: zDateOnly,
  endDate: zDateOnly,
  title: z4.string().max(160).optional()
});
var zMealLibraryItem = z4.object({
  id: zId,
  name: z4.string(),
  category: z4.string().nullable(),
  description: z4.string().nullable(),
  portion: z4.string().nullable(),
  macros: zMacros.nullable(),
  tags: z4.array(z4.string()),
  suitableSlots: z4.array(z4.nativeEnum(MealSlot)),
  items: z4.array(zMealItem),
  usageCount: z4.number().int(),
  createdAt: z4.string()
});
var zCreateMealLibraryItemInput = z4.object({
  name: z4.string().trim().min(2).max(160),
  category: z4.string().max(60).optional(),
  description: z4.string().max(1e3).optional(),
  portion: z4.string().max(120).optional(),
  macros: zMacros.optional(),
  tags: z4.array(z4.string().max(40)).max(12).default([]),
  suitableSlots: z4.array(z4.nativeEnum(MealSlot)).default([]),
  items: z4.array(zMealItem).default([])
});
var zRecipe = z4.object({
  id: zId,
  title: z4.string(),
  summary: z4.string().nullable(),
  imageUrl: z4.string().nullable(),
  prepMinutes: z4.number().int().nullable(),
  cookMinutes: z4.number().int().nullable(),
  servings: z4.number().int(),
  macrosPerServing: zMacros.nullable(),
  ingredients: z4.array(z4.object({ name: z4.string(), quantity: z4.string().nullable() })),
  steps: z4.array(z4.string()),
  tags: z4.array(z4.string()),
  isPublished: z4.boolean(),
  createdAt: z4.string()
});
var zCreateRecipeInput = z4.object({
  title: z4.string().trim().min(2).max(200),
  summary: z4.string().max(1e3).optional(),
  imageKey: z4.string().max(256).optional(),
  prepMinutes: z4.number().int().min(0).max(1440).optional(),
  cookMinutes: z4.number().int().min(0).max(1440).optional(),
  servings: z4.number().int().min(1).max(50).default(1),
  macrosPerServing: zMacros.optional(),
  ingredients: z4.array(z4.object({ name: z4.string().min(1).max(160), quantity: z4.string().max(60).optional() })).default([]),
  steps: z4.array(z4.string().min(1).max(1e3)).default([]),
  tags: z4.array(z4.string().max(40)).max(12).default([]),
  isPublished: z4.boolean().default(false)
});
var zShoppingListItem = z4.object({
  id: zId,
  name: z4.string(),
  quantity: z4.string().nullable(),
  category: z4.enum(GROCERY_CATEGORIES),
  checked: z4.boolean(),
  /** Kullanıcı elle eklediyse true. */
  isCustom: z4.boolean()
});
var zShoppingList = z4.object({
  id: zId,
  clientId: zId,
  planId: zId.nullable(),
  weekStart: z4.string(),
  weekEnd: z4.string(),
  generatedAt: z4.string(),
  items: z4.array(zShoppingListItem)
});
var zGenerateShoppingListInput = z4.object({
  weekStart: zDateOnly,
  /** Var olan listeyi sıfırlayıp yeniden üret. */
  regenerate: z4.boolean().default(false)
});
var zUpdateShoppingItemInput = z4.object({
  checked: z4.boolean().optional(),
  name: z4.string().max(160).optional(),
  quantity: z4.string().max(60).nullable().optional()
});

// src/schemas/tracking.ts
import { z as z5 } from "zod";
var zSetMealLogInput = z5.object({
  planMealId: zId,
  date: zDateOnly,
  status: z5.nativeEnum(MealLogStatus),
  note: z5.string().max(500).nullable().optional(),
  /** Alternatif seçildiyse hangisi. */
  alternativeId: zId.nullable().optional()
});
var zMealLog = z5.object({
  id: zId,
  clientId: zId,
  planMealId: zId.nullable(),
  date: z5.string(),
  slot: z5.nativeEnum(MealSlot),
  status: z5.nativeEnum(MealLogStatus),
  completedAt: z5.string().nullable(),
  note: z5.string().nullable(),
  alternativeId: zId.nullable(),
  photoCount: z5.number().int()
});
var zPresignUploadInput = z5.object({
  fileName: z5.string().max(200),
  mimeType: z5.string().regex(/^image\/(jpeg|png|webp|heic|heif)$/, "Desteklenmeyen g\xF6rsel t\xFCr\xFC"),
  sizeBytes: z5.number().int().min(1),
  purpose: z5.enum(["MEAL_PHOTO", "MESSAGE_ATTACHMENT", "AVATAR", "PROGRESS_PHOTO", "RECIPE"])
});
var zPresignUploadResponse = z5.object({
  uploadUrl: z5.string(),
  /** Doğrudan PUT mü yoksa çok parçalı form mu. */
  method: z5.enum(["PUT", "POST"]),
  headers: z5.record(z5.string(), z5.string()),
  key: z5.string(),
  expiresAt: z5.string()
});
var zCreateMealPhotoInput = z5.object({
  key: z5.string().min(4).max(256),
  /** Yükleme ucunun ürettiği önizleme anahtarı; yoksa liste küçük görselsiz döner. */
  thumbnailKey: z5.string().max(256).nullable().optional(),
  date: zDateOnly,
  slot: z5.nativeEnum(MealSlot),
  planMealId: zId.nullable().optional(),
  note: z5.string().max(500).nullable().optional(),
  takenAt: z5.string().datetime({ offset: true }).optional(),
  /**
   * İstemcinin ürettiği tekil anahtar. Aynı fotoğraf iki kez gönderilse de
   * tek kayıt oluşur (PDF ekran 04 kuralı).
   */
  clientUploadId: z5.string().min(8).max(64)
});
var zPhotoAiAnalysis = z5.object({
  detectedItems: z5.array(z5.string()),
  estimatedCalories: z5.number().nullable(),
  portionAssessment: z5.enum(["UNDER", "ON_TARGET", "OVER", "UNCLEAR"]),
  matchesPlan: z5.enum(["YES", "PARTIAL", "NO", "UNCLEAR"]),
  /** Diyetisyenin düzenleyip gönderebileceği taslak metin. */
  draftFeedback: z5.string(),
  confidence: z5.number().min(0).max(1),
  model: z5.string(),
  generatedAt: z5.string()
});
var zMealPhoto = z5.object({
  id: zId,
  clientId: zId,
  clientName: z5.string().optional(),
  clientAvatarUrl: z5.string().nullable().optional(),
  mealLogId: zId.nullable(),
  planMealId: zId.nullable(),
  date: z5.string(),
  slot: z5.nativeEnum(MealSlot),
  imageUrl: z5.string(),
  thumbnailUrl: z5.string().nullable(),
  note: z5.string().nullable(),
  takenAt: z5.string(),
  createdAt: z5.string(),
  reviewStatus: z5.nativeEnum(PhotoReviewStatus),
  /** Planda o öğünde ne vardı — yan yana değerlendirme için. */
  plannedMeal: z5.object({
    title: z5.string(),
    description: z5.string().nullable(),
    portion: z5.string().nullable(),
    time: z5.string()
  }).nullable(),
  feedback: z5.object({
    id: zId,
    body: z5.string(),
    dietitianName: z5.string(),
    createdAt: z5.string()
  }).nullable(),
  /** Yalnızca diyetisyen/yönetici yanıtlarında dolu. */
  aiAnalysis: zPhotoAiAnalysis.nullable().optional()
});
var zMealPhotoQuery = zPagination.extend({
  clientId: zId.optional(),
  reviewStatus: z5.nativeEnum(PhotoReviewStatus).optional(),
  from: zDateOnly.optional(),
  to: zDateOnly.optional(),
  slot: z5.nativeEnum(MealSlot).optional(),
  assignedToMe: z5.coerce.boolean().optional()
});
var zSendPhotoFeedbackInput = z5.object({
  body: z5.string().trim().min(1, "Geri bildirim bo\u015F olamaz").max(4e3),
  /** Geri bildirim sohbete de düşsün mü. */
  alsoSendToConversation: z5.boolean().default(true)
});
var zMeasurement = z5.object({
  id: zId,
  clientId: zId,
  clientName: z5.string().optional(),
  date: z5.string(),
  weightKg: z5.number().nullable(),
  heightCm: z5.number().nullable(),
  waistCm: z5.number().nullable(),
  hipCm: z5.number().nullable(),
  chestCm: z5.number().nullable(),
  armCm: z5.number().nullable(),
  thighCm: z5.number().nullable(),
  bodyFatPct: z5.number().nullable(),
  muscleMassKg: z5.number().nullable(),
  visceralFat: z5.number().nullable(),
  bmi: z5.number().nullable(),
  /** Diyetisyenin danışana yayımladığı değerlendirme. */
  evaluation: z5.string().nullable(),
  /** Yalnızca ekip görür. */
  internalNote: z5.string().nullable().optional(),
  published: z5.boolean(),
  publishedAt: z5.string().nullable(),
  recordedByName: z5.string().nullable(),
  createdAt: z5.string(),
  updatedAt: z5.string()
});
var zCreateMeasurementInput = z5.object({
  clientId: zId,
  date: zDateOnly,
  weightKg: z5.number().min(25).max(400).nullable().optional(),
  heightCm: z5.number().min(80).max(250).nullable().optional(),
  waistCm: z5.number().min(30).max(250).nullable().optional(),
  hipCm: z5.number().min(30).max(250).nullable().optional(),
  chestCm: z5.number().min(30).max(250).nullable().optional(),
  armCm: z5.number().min(10).max(100).nullable().optional(),
  thighCm: z5.number().min(20).max(150).nullable().optional(),
  bodyFatPct: z5.number().min(1).max(70).nullable().optional(),
  muscleMassKg: z5.number().min(5).max(150).nullable().optional(),
  visceralFat: z5.number().min(1).max(60).nullable().optional(),
  evaluation: z5.string().max(4e3).nullable().optional(),
  internalNote: z5.string().max(4e3).nullable().optional(),
  /** Kaydet ve yayınla / sadece taslak olarak sakla. */
  publish: z5.boolean().default(false)
}).refine(
  (v) => v.weightKg != null || v.waistCm != null || v.hipCm != null || v.bodyFatPct != null || v.muscleMassKg != null,
  { message: "En az bir \xF6l\xE7\xFCm de\u011Feri girilmeli", path: ["weightKg"] }
);
var zUpdateMeasurementInput = z5.object({
  date: zDateOnly.optional(),
  weightKg: z5.number().min(25).max(400).nullable().optional(),
  heightCm: z5.number().min(80).max(250).nullable().optional(),
  waistCm: z5.number().min(30).max(250).nullable().optional(),
  hipCm: z5.number().min(30).max(250).nullable().optional(),
  chestCm: z5.number().min(30).max(250).nullable().optional(),
  armCm: z5.number().min(10).max(100).nullable().optional(),
  thighCm: z5.number().min(20).max(150).nullable().optional(),
  bodyFatPct: z5.number().min(1).max(70).nullable().optional(),
  muscleMassKg: z5.number().min(5).max(150).nullable().optional(),
  visceralFat: z5.number().min(1).max(60).nullable().optional(),
  evaluation: z5.string().max(4e3).nullable().optional(),
  internalNote: z5.string().max(4e3).nullable().optional(),
  publish: z5.boolean().optional()
});
var zProgressSummary = z5.object({
  startWeightKg: z5.number().nullable(),
  latestWeightKg: z5.number().nullable(),
  targetWeightKg: z5.number().nullable(),
  /** Başlangıca göre fark; negatif = kayıp. */
  totalChangeKg: z5.number().nullable(),
  lastPeriodChangeKg: z5.number().nullable(),
  latestMeasurementDate: z5.string().nullable(),
  bmi: z5.number().nullable(),
  /** Hedefe ne kadar yaklaşıldı (0-1); hedef yoksa null. */
  goalProgress: z5.number().min(0).max(1).nullable(),
  /**
   * Ölçüm yapılan haftalar. Ölçümsüz haftalar listede yer almaz —
   * uydurma değer üretilmez (PDF ekran 07 ve 10 kuralı).
   */
  series: z5.array(
    z5.object({
      date: z5.string(),
      weekLabel: z5.string(),
      weightKg: z5.number().nullable(),
      waistCm: z5.number().nullable(),
      bodyFatPct: z5.number().nullable()
    })
  ),
  latestEvaluation: z5.object({ body: z5.string(), dietitianName: z5.string(), publishedAt: z5.string() }).nullable()
});
var zLogWaterInput = z5.object({
  date: zDateOnly,
  /** Pozitif ekler, negatif geri alır. */
  amountMl: z5.number().int().min(-5e3).max(5e3)
});
var zWaterDay = z5.object({
  date: z5.string(),
  totalMl: z5.number().int(),
  goalMl: z5.number().int(),
  entries: z5.array(z5.object({ id: zId, amountMl: z5.number().int(), loggedAt: z5.string() }))
});
var zWellbeingInput = z5.object({
  date: zDateOnly,
  mood: z5.number().int().min(1).max(5).nullable().optional(),
  energy: z5.number().int().min(1).max(5).nullable().optional(),
  sleepHours: z5.number().min(0).max(24).nullable().optional(),
  sleepQuality: z5.number().int().min(1).max(5).nullable().optional(),
  note: z5.string().max(1e3).nullable().optional()
});
var zWellbeingLog = zWellbeingInput.extend({
  id: zId,
  clientId: zId,
  createdAt: z5.string()
});
var zSyncStepsInput = z5.object({
  entries: z5.array(z5.object({ date: zDateOnly, steps: z5.number().int().min(0).max(2e5) })).min(1).max(90),
  source: z5.enum(["HEALTHKIT", "HEALTH_CONNECT", "MANUAL"])
});
var zStreak = z5.object({
  currentDays: z5.number().int(),
  longestDays: z5.number().int(),
  lastActiveDate: z5.string().nullable(),
  /** Bugün streak korunmuş mu. */
  todaySecured: z5.boolean()
});
var zBadge = z5.object({
  code: z5.nativeEnum(BadgeCode),
  earnedAt: z5.string().nullable(),
  progress: z5.number().min(0).max(1)
});
var zTodaySummary = z5.object({
  date: z5.string(),
  greetingName: z5.string(),
  hasPlan: z5.boolean(),
  completedMeals: z5.number().int(),
  totalMeals: z5.number().int(),
  nextMeal: z5.object({
    planMealId: zId,
    slot: z5.nativeEnum(MealSlot),
    time: z5.string(),
    title: z5.string(),
    description: z5.string().nullable()
  }).nullable(),
  water: z5.object({ totalMl: z5.number().int(), goalMl: z5.number().int() }),
  streak: zStreak,
  unreadMessages: z5.number().int(),
  unreadNotifications: z5.number().int(),
  pendingQuestionAnswered: z5.boolean(),
  nextAppointment: z5.object({
    id: zId,
    startsAt: z5.string(),
    durationMinutes: z5.number().int(),
    type: z5.enum(["ONLINE_CALL", "IN_PERSON"]),
    dietitianName: z5.string(),
    location: z5.string().nullable()
  }).nullable(),
  latestWeightKg: z5.number().nullable(),
  weightChangeKg: z5.number().nullable(),
  /** Paket bitişine az kaldıysa ekranda uyarı çıkar. */
  packageDaysRemaining: z5.number().int().nullable(),
  newBadges: z5.array(zBadge)
});
var zHistoryWeek = z5.object({
  weekStart: z5.string(),
  weekEnd: z5.string(),
  planId: zId.nullable(),
  planTitle: z5.string().nullable(),
  planVersion: z5.number().int().nullable(),
  completedMeals: z5.number().int(),
  totalMeals: z5.number().int(),
  photoCount: z5.number().int(),
  measurementCount: z5.number().int()
});
var zHistoryDay = z5.object({
  date: z5.string(),
  meals: z5.array(
    z5.object({
      slot: z5.nativeEnum(MealSlot),
      time: z5.string(),
      title: z5.string(),
      status: z5.nativeEnum(MealLogStatus),
      clientNote: z5.string().nullable(),
      photos: z5.array(
        z5.object({
          id: zId,
          thumbnailUrl: z5.string().nullable(),
          imageUrl: z5.string(),
          feedback: z5.string().nullable()
        })
      )
    })
  ),
  water: z5.object({ totalMl: z5.number().int(), goalMl: z5.number().int() }),
  wellbeing: zWellbeingLog.nullable(),
  steps: z5.number().int().nullable()
});

// src/schemas/comms.ts
import { z as z6 } from "zod";
var zMessage = z6.object({
  id: zId,
  conversationId: zId,
  senderId: zId,
  senderName: z6.string(),
  senderRole: z6.enum(["ADMIN", "DIETITIAN", "CLIENT", "SYSTEM"]),
  senderAvatarUrl: z6.string().nullable(),
  type: z6.nativeEnum(MessageType),
  body: z6.string().nullable(),
  attachmentUrl: z6.string().nullable(),
  attachmentThumbnailUrl: z6.string().nullable(),
  mealPhotoId: zId.nullable(),
  callId: zId.nullable(),
  isQuestion: z6.boolean(),
  questionStatus: z6.nativeEnum(QuestionStatus).nullable(),
  priority: z6.nativeEnum(QuestionPriority).nullable(),
  createdAt: z6.string(),
  deliveredAt: z6.string().nullable(),
  readAt: z6.string().nullable(),
  /** Gönderen istemcinin ürettiği anahtar — iyimser gönderim eşleşmesi. */
  clientMessageId: z6.string().nullable(),
  /** Yanıtlanan mesaj. */
  replyTo: z6.object({ id: zId, body: z6.string().nullable(), senderName: z6.string() }).nullable()
});
var zSendMessageInput = z6.object({
  conversationId: zId,
  type: z6.nativeEnum(MessageType).default(MessageType.TEXT),
  body: z6.string().max(4e3).nullable().optional(),
  attachmentKey: z6.string().max(256).nullable().optional(),
  mealPhotoId: zId.nullable().optional(),
  replyToId: zId.nullable().optional(),
  /** Danışan "soru olarak gönder" derse bekleyenler listesine düşer. */
  isQuestion: z6.boolean().default(false),
  /** Aynı mesajın iki kez kaydolmaması için istemci anahtarı. */
  clientMessageId: z6.string().min(8).max(64)
});
var zConversationListItem = z6.object({
  id: zId,
  clientId: zId,
  clientName: z6.string(),
  clientAvatarUrl: z6.string().nullable(),
  dietitianId: zId,
  dietitianName: z6.string(),
  lastMessage: z6.object({
    body: z6.string().nullable(),
    type: z6.nativeEnum(MessageType),
    createdAt: z6.string(),
    senderRole: z6.string()
  }).nullable(),
  unreadCount: z6.number().int(),
  openQuestionCount: z6.number().int(),
  clientOnline: z6.boolean(),
  updatedAt: z6.string()
});
var zMessageListQuery = z6.object({
  /** İmleç tabanlı sayfalama — sohbet geçmişi geriye doğru yüklenir. */
  before: z6.string().optional(),
  limit: z6.coerce.number().int().min(1).max(100).default(40)
});
var zPendingQuestion = z6.object({
  messageId: zId,
  conversationId: zId,
  clientId: zId,
  clientName: z6.string(),
  clientAvatarUrl: z6.string().nullable(),
  summary: z6.string(),
  askedAt: z6.string(),
  /** Bekleme süresi (dakika) — listede "18 dk" olarak gösterilir. */
  waitingMinutes: z6.number().int(),
  status: z6.nativeEnum(QuestionStatus),
  priority: z6.nativeEnum(QuestionPriority),
  assignedToId: zId.nullable(),
  assignedToName: z6.string().nullable(),
  isOverdue: z6.boolean()
});
var zPendingQuestionQuery = zPagination.extend({
  status: z6.nativeEnum(QuestionStatus).optional(),
  priority: z6.nativeEnum(QuestionPriority).optional(),
  assignedToMe: z6.coerce.boolean().optional(),
  clientId: zId.optional()
});
var zUpdateQuestionInput = z6.object({
  priority: z6.nativeEnum(QuestionPriority).optional(),
  assignedToId: zId.nullable().optional(),
  status: z6.nativeEnum(QuestionStatus).optional()
});
var zCall = z6.object({
  id: zId,
  conversationId: zId,
  initiatorId: zId,
  initiatorName: z6.string(),
  receiverId: zId,
  receiverName: z6.string(),
  status: z6.nativeEnum(CallStatus),
  media: z6.nativeEnum(CallMedia),
  startedAt: z6.string().nullable(),
  answeredAt: z6.string().nullable(),
  endedAt: z6.string().nullable(),
  durationSeconds: z6.number().int().nullable(),
  appointmentId: zId.nullable(),
  createdAt: z6.string()
});
var zStartCallInput = z6.object({
  conversationId: zId,
  /** Verilmezse sesli aranır — eski istemciler bu alanı göndermiyor. */
  media: z6.nativeEnum(CallMedia).default(CallMedia.AUDIO),
  appointmentId: zId.nullable().optional()
});
var zIceServers = z6.object({
  iceServers: z6.array(
    z6.object({
      urls: z6.union([z6.string(), z6.array(z6.string())]),
      username: z6.string().optional(),
      credential: z6.string().optional()
    })
  ),
  expiresAt: z6.string()
});
var zCallSignal = z6.object({
  callId: zId,
  /** SDP teklifi / yanıtı ya da ICE adayı. */
  sdp: z6.string().optional(),
  candidate: z6.object({
    candidate: z6.string(),
    sdpMid: z6.string().nullable().optional(),
    sdpMLineIndex: z6.number().nullable().optional()
  }).optional()
});
var zAppointment = z6.object({
  id: zId,
  clientId: zId,
  clientName: z6.string(),
  clientAvatarUrl: z6.string().nullable(),
  dietitianId: zId,
  dietitianName: z6.string(),
  startsAt: z6.string(),
  endsAt: z6.string(),
  durationMinutes: z6.number().int(),
  type: z6.nativeEnum(AppointmentType),
  status: z6.nativeEnum(AppointmentStatus),
  location: z6.string().nullable(),
  note: z6.string().nullable(),
  /** Danışanın değişiklik talebindeki açıklaması. */
  clientNote: z6.string().nullable(),
  /** Görüşme sonrası diyetisyen notu — danışan dosyasına işlenir. */
  outcomeNote: z6.string().nullable().optional(),
  callId: zId.nullable(),
  createdAt: z6.string()
});
var zCreateAppointmentInput = z6.object({
  clientId: zId,
  dietitianId: zId.optional(),
  startsAt: zDateTime,
  durationMinutes: z6.number().int().min(10).max(240).default(30),
  type: z6.nativeEnum(AppointmentType),
  location: z6.string().max(240).optional(),
  note: z6.string().max(2e3).optional(),
  notifyClient: z6.boolean().default(true)
});
var zUpdateAppointmentInput = z6.object({
  startsAt: zDateTime.optional(),
  durationMinutes: z6.number().int().min(10).max(240).optional(),
  type: z6.nativeEnum(AppointmentType).optional(),
  status: z6.nativeEnum(AppointmentStatus).optional(),
  location: z6.string().max(240).nullable().optional(),
  note: z6.string().max(2e3).nullable().optional(),
  outcomeNote: z6.string().max(4e3).nullable().optional(),
  notifyClient: z6.boolean().default(true)
});
var zRequestRescheduleInput = z6.object({
  reason: z6.string().max(1e3),
  preferredSlots: z6.array(zDateTime).max(5).default([])
});
var zAppointmentQuery = z6.object({
  from: zDateOnly.optional(),
  to: zDateOnly.optional(),
  clientId: zId.optional(),
  dietitianId: zId.optional(),
  status: z6.nativeEnum(AppointmentStatus).optional(),
  type: z6.nativeEnum(AppointmentType).optional()
});
var zAvailabilityQuery = z6.object({
  dietitianId: zId,
  date: zDateOnly,
  durationMinutes: z6.coerce.number().int().min(10).max(240).default(30)
});
var zAvailability = z6.object({
  date: z6.string(),
  busy: z6.array(z6.object({ startsAt: z6.string(), endsAt: z6.string(), appointmentId: zId })),
  suggestions: z6.array(z6.string())
});
var zNotification = z6.object({
  id: zId,
  event: z6.nativeEnum(NotificationEvent),
  title: z6.string(),
  body: z6.string(),
  /** Dokununca nereye gidileceği — mobil derin bağlantı. */
  deepLink: z6.string().nullable(),
  data: z6.record(z6.string(), z6.unknown()).nullable(),
  readAt: z6.string().nullable(),
  createdAt: z6.string()
});
var zNotificationQuery = zPagination.extend({
  unreadOnly: z6.coerce.boolean().optional()
});
var zBroadcastInput = z6.object({
  title: z6.string().trim().min(2).max(120),
  body: z6.string().trim().min(2).max(2e3),
  segment: z6.object({
    serviceType: z6.enum(["ONLINE", "IN_PERSON"]).optional(),
    onlyActive: z6.boolean().default(true),
    dietitianId: zId.optional(),
    clientIds: z6.array(zId).max(500).optional()
  }),
  channels: z6.array(z6.enum(["IN_APP", "PUSH"])).min(1).default(["IN_APP", "PUSH"])
});

// src/schemas/admin.ts
import { z as z7 } from "zod";
var zDashboard = z7.object({
  scope: z7.enum(["ALL", "ASSIGNED"]),
  metrics: z7.object({
    activeClients: z7.number().int(),
    activeClientsTrendPct: z7.number().nullable(),
    pendingQuestions: z7.number().int(),
    overdueQuestions: z7.number().int(),
    photosAwaitingReview: z7.number().int(),
    todayAppointments: z7.number().int(),
    expiringPackages: z7.number().int(),
    pendingInvitations: z7.number().int()
  }),
  /** Haftalık aktif danışan serisi — genel bakıştaki grafik. */
  weeklySeries: z7.array(z7.object({ label: z7.string(), value: z7.number().int() })),
  /** "Bugünün işleri" listesi. */
  tasks: z7.array(
    z7.object({
      id: z7.string(),
      kind: z7.enum([
        "MEASUREMENT_DUE",
        "OPEN_QUESTION",
        "PHOTO_REVIEW",
        "APPOINTMENT",
        "PACKAGE_EXPIRING",
        "INVITATION_PENDING",
        "RESCHEDULE_REQUEST"
      ]),
      clientId: zId,
      clientName: z7.string(),
      clientAvatarUrl: z7.string().nullable(),
      label: z7.string(),
      detail: z7.string().nullable(),
      dueAt: z7.string().nullable(),
      urgency: z7.enum(["LOW", "NORMAL", "HIGH"]),
      deepLink: z7.string()
    })
  )
});
var zNotificationRule = z7.object({
  id: zId,
  event: z7.nativeEnum(NotificationEvent),
  audience: z7.nativeEnum(NotificationAudience),
  timing: z7.nativeEnum(NotificationTiming),
  offsetMinutes: z7.number().int(),
  channels: z7.array(z7.nativeEnum(NotificationChannel)),
  enabled: z7.boolean(),
  /** Şablon metni — {{clientName}} gibi yer tutucular desteklenir. */
  titleTemplate: z7.string().nullable(),
  bodyTemplate: z7.string().nullable(),
  updatedAt: z7.string(),
  updatedByName: z7.string().nullable()
});
var zUpdateNotificationRuleInput = z7.object({
  timing: z7.nativeEnum(NotificationTiming).optional(),
  offsetMinutes: z7.number().int().min(0).max(60 * 24 * 30).optional(),
  channels: z7.array(z7.nativeEnum(NotificationChannel)).min(0).optional(),
  enabled: z7.boolean().optional(),
  titleTemplate: z7.string().max(200).nullable().optional(),
  bodyTemplate: z7.string().max(1e3).nullable().optional()
});
var zNotificationDelivery = z7.object({
  id: zId,
  notificationId: zId,
  event: z7.nativeEnum(NotificationEvent),
  recipientName: z7.string(),
  recipientRole: z7.nativeEnum(UserRole),
  channel: z7.nativeEnum(NotificationChannel),
  status: z7.nativeEnum(DeliveryStatus),
  error: z7.string().nullable(),
  attempts: z7.number().int(),
  sentAt: z7.string().nullable(),
  createdAt: z7.string()
});
var zDeliveryQuery = zPagination.extend({
  status: z7.nativeEnum(DeliveryStatus).optional(),
  channel: z7.nativeEnum(NotificationChannel).optional(),
  event: z7.nativeEnum(NotificationEvent).optional(),
  from: zDateOnly.optional(),
  to: zDateOnly.optional()
});
var zReportQuery = z7.object({
  from: zDateOnly,
  to: zDateOnly,
  dietitianId: zId.optional(),
  serviceType: z7.enum(["ONLINE", "IN_PERSON"]).optional()
});
var zBusinessReport = z7.object({
  period: z7.object({ from: z7.string(), to: z7.string() }),
  clients: z7.object({
    active: z7.number().int(),
    newInPeriod: z7.number().int(),
    churnedInPeriod: z7.number().int(),
    online: z7.number().int(),
    inPerson: z7.number().int()
  }),
  packages: z7.object({
    activeCount: z7.number().int(),
    expiringCount: z7.number().int(),
    renewedCount: z7.number().int(),
    renewalRate: z7.number().min(0).max(1)
  }),
  revenue: z7.object({
    total: z7.number(),
    currency: z7.string(),
    verified: z7.number(),
    pending: z7.number(),
    byMethod: z7.array(
      z7.object({ method: z7.string(), amount: z7.number(), count: z7.number().int() })
    ),
    monthly: z7.array(z7.object({ month: z7.string(), amount: z7.number() }))
  }),
  engagement: z7.object({
    appointmentsCompleted: z7.number().int(),
    appointmentsNoShow: z7.number().int(),
    questionsAnswered: z7.number().int(),
    medianResponseMinutes: z7.number().nullable(),
    photosReviewed: z7.number().int(),
    avgMealAdherence: z7.number().min(0).max(1),
    plansPublished: z7.number().int()
  }),
  /** Diyetisyen bazlı kırılım — yalnızca yöneticiye. */
  byDietitian: z7.array(
    z7.object({
      dietitianId: zId,
      name: z7.string(),
      activeClients: z7.number().int(),
      plansPublished: z7.number().int(),
      questionsAnswered: z7.number().int(),
      medianResponseMinutes: z7.number().nullable(),
      avgAdherence: z7.number().min(0).max(1)
    })
  ).optional()
});
var zWeeklyReportInput = z7.object({
  clientId: zId,
  weekStart: zDateOnly,
  includePhotos: z7.boolean().default(true),
  includeMeasurements: z7.boolean().default(true),
  dietitianNote: z7.string().max(4e3).optional(),
  sendToClient: z7.boolean().default(true)
});
var zTeamMember = z7.object({
  id: zId,
  fullName: z7.string(),
  email: z7.string(),
  role: z7.nativeEnum(UserRole),
  status: z7.nativeEnum(UserStatus),
  avatarUrl: z7.string().nullable(),
  assignedClientCount: z7.number().int(),
  lastLoginAt: z7.string().nullable(),
  createdAt: z7.string()
});
var zInviteTeamMemberInput = z7.object({
  fullName: z7.string().trim().min(2).max(120),
  email: zEmail,
  role: z7.enum([UserRole.ADMIN, UserRole.DIETITIAN]),
  title: z7.string().max(120).optional()
});
var zUpdateTeamMemberInput = z7.object({
  role: z7.enum([UserRole.ADMIN, UserRole.DIETITIAN]).optional(),
  status: z7.enum([UserStatus.ACTIVE, UserStatus.SUSPENDED]).optional(),
  fullName: z7.string().trim().min(2).max(120).optional(),
  title: z7.string().max(120).nullable().optional()
});
var zAssignClientsInput = z7.object({
  dietitianId: zId,
  clientIds: z7.array(zId).min(1).max(200)
});
var zAuditLogEntry = z7.object({
  id: zId,
  action: z7.nativeEnum(AuditAction),
  actorId: zId.nullable(),
  actorName: z7.string().nullable(),
  actorRole: z7.nativeEnum(UserRole).nullable(),
  entityType: z7.string(),
  entityId: z7.string().nullable(),
  summary: z7.string(),
  meta: z7.record(z7.string(), z7.unknown()).nullable(),
  ip: z7.string().nullable(),
  createdAt: z7.string()
});
var zAuditQuery = zPagination.extend({
  action: z7.nativeEnum(AuditAction).optional(),
  actorId: zId.optional(),
  entityType: z7.string().max(60).optional(),
  entityId: z7.string().max(64).optional(),
  from: zDateOnly.optional(),
  to: zDateOnly.optional()
});
var zDataRequest = z7.object({
  id: zId,
  userId: zId,
  userName: z7.string(),
  type: z7.nativeEnum(DataRequestType),
  status: z7.nativeEnum(DataRequestStatus),
  reason: z7.string().nullable(),
  requestedAt: z7.string(),
  completedAt: z7.string().nullable(),
  downloadUrl: z7.string().nullable(),
  handledByName: z7.string().nullable()
});
var zCreateDataRequestInput = z7.object({
  type: z7.nativeEnum(DataRequestType),
  reason: z7.string().max(1e3).optional()
});
var zResolveDataRequestInput = z7.object({
  status: z7.enum([DataRequestStatus.COMPLETED, DataRequestStatus.REJECTED]),
  note: z7.string().max(1e3).optional()
});
var zOrganizationSettings = z7.object({
  name: z7.string(),
  legalName: z7.string().nullable(),
  logoUrl: z7.string().nullable(),
  addressLine: z7.string().nullable(),
  city: z7.string().nullable(),
  phone: z7.string().nullable(),
  email: z7.string().nullable(),
  website: z7.string().nullable(),
  timezone: z7.string(),
  currency: z7.string(),
  /** Yüz yüze görüşmelerin varsayılan konumu. */
  defaultLocation: z7.string().nullable(),
  /** Çalışma saatleri — randevu çakışma kontrolü kullanır. */
  workingHours: z7.array(
    z7.object({
      dayOfWeek: z7.number().int().min(1).max(7),
      start: z7.string(),
      end: z7.string(),
      closed: z7.boolean()
    })
  )
});
var zUpdateOrganizationSettingsInput = zOrganizationSettings.partial().omit({ logoUrl: true }).extend({
  logoKey: z7.string().max(256).nullable().optional()
});

// src/schemas/exchange.ts
import { z as z8 } from "zod";
var zExchangeItem = z8.object({
  id: zId,
  groupKey: z8.nativeEnum(ExchangeGroupKey),
  name: z8.string(),
  /** "1 su bardağı", "1 yumurta büyüklüğünde" gibi pratik ölçü. */
  measure: z8.string(),
  grams: z8.number().nullable(),
  /** "Kuru meyveler", "Meyve suları" gibi alt başlık. */
  subgroup: z8.string().nullable(),
  /** Miktar pişmiş ağırlık mı. */
  cooked: z8.boolean(),
  order: z8.number().int()
});
var zExchangeGroup = z8.object({
  id: zId,
  key: z8.nativeEnum(ExchangeGroupKey),
  name: z8.string(),
  order: z8.number().int(),
  calories: z8.number().nullable(),
  proteinG: z8.number().nullable(),
  carbsG: z8.number().nullable(),
  fatG: z8.number().nullable(),
  note: z8.string().nullable(),
  items: z8.array(zExchangeItem)
});
var zCompositeDishPart = z8.object({
  groupKey: z8.nativeEnum(ExchangeGroupKey),
  amount: z8.number()
});
var zCompositeDish = z8.object({
  id: zId,
  name: z8.string(),
  measure: z8.string(),
  order: z8.number().int(),
  parts: z8.array(zCompositeDishPart)
});
var zDietaryRule = z8.object({
  id: zId,
  kind: z8.nativeEnum(DietaryRuleKind),
  text: z8.string(),
  order: z8.number().int()
});
var zExchangeLibrary = z8.object({
  groups: z8.array(zExchangeGroup),
  dishes: z8.array(zCompositeDish),
  rules: z8.array(zDietaryRule)
});
var zExchangeSlotPortion = z8.object({
  slot: z8.nativeEnum(MealSlot),
  amount: z8.number().min(0)
});
var zExchangePortion = z8.object({
  groupKey: z8.nativeEnum(ExchangeGroupKey),
  perDay: z8.number().min(0),
  slots: z8.array(zExchangeSlotPortion)
});
var zExchangePrescription = z8.object({
  id: zId,
  planId: zId,
  targetCalories: z8.number().int().nullable(),
  note: z8.string().nullable(),
  portions: z8.array(zExchangePortion)
});
var zSaveExchangePrescriptionInput = z8.object({
  targetCalories: z8.number().int().min(0).max(1e4).nullable().optional(),
  note: z8.string().max(2e3).nullable().optional(),
  portions: z8.array(
    zExchangePortion.superRefine((portion, ctx) => {
      const dagitilan = portion.slots.reduce((toplam, s) => toplam + s.amount, 0);
      if (dagitilan - portion.perDay > 1e-3) {
        ctx.addIssue({
          code: z8.ZodIssueCode.custom,
          message: `${portion.groupKey}: \xF6\u011F\xFCnlere da\u011F\u0131t\u0131lan porsiyon (${dagitilan}) g\xFCnl\xFCk toplam\u0131 (${portion.perDay}) a\u015F\u0131yor.`
        });
      }
    })
  ).max(7)
});
var zUpsertExchangeItemInput = z8.object({
  groupKey: z8.nativeEnum(ExchangeGroupKey),
  name: z8.string().min(1).max(120),
  measure: z8.string().min(1).max(120),
  grams: z8.number().min(0).max(5e3).nullable().optional(),
  subgroup: z8.string().max(80).nullable().optional(),
  cooked: z8.boolean().optional(),
  order: z8.number().int().min(0).max(999).optional()
});
var zUpsertDietaryRuleInput = z8.object({
  kind: z8.nativeEnum(DietaryRuleKind),
  text: z8.string().min(1).max(500),
  order: z8.number().int().min(0).max(999).optional()
});
var zLogExchangeInput = z8.object({
  date: z8.string(),
  slot: z8.nativeEnum(MealSlot),
  itemId: zId.optional(),
  dishId: zId.optional(),
  /** Kaç porsiyon / kaç ölçü. */
  quantity: z8.number().min(0.25).max(20).default(1),
  note: z8.string().max(500).optional()
}).refine((v) => Boolean(v.itemId) !== Boolean(v.dishId), {
  message: "Ya bir de\u011Fi\u015Fim kalemi ya da bir bile\u015Fik yemek se\xE7ilmeli."
});
var zExchangeDayTally = z8.object({
  date: z8.string(),
  groups: z8.array(
    z8.object({
      groupKey: z8.nativeEnum(ExchangeGroupKey),
      target: z8.number(),
      consumed: z8.number(),
      remaining: z8.number()
    })
  )
});
export {
  API_PREFIX,
  ActivityLevel,
  AppointmentStatus,
  AppointmentType,
  AuditAction,
  BADGE_META,
  BMI_CATEGORY_LABELS_TR,
  BadgeCode,
  CallMedia,
  CallStatus,
  ClientGoal,
  ConsentType,
  DEEP_LINK_SCHEME,
  DEFAULT_MEAL_TIMES,
  DEFAULT_NOTIFICATION_RULES,
  DataRequestStatus,
  DataRequestType,
  DeliveryStatus,
  DietaryPreference,
  DietaryRuleKind,
  ERROR_MESSAGES_EN,
  ERROR_MESSAGES_TR,
  ERROR_STATUS,
  EXCHANGE_GROUP_LABELS,
  EXCHANGE_GROUP_ORDER,
  ErrorCode,
  ExchangeGroupKey,
  GROCERY_CATEGORIES,
  GROCERY_CATEGORY_LABELS_TR,
  Locale,
  MEAL_SLOT_LABELS_EN,
  MEAL_SLOT_LABELS_TR,
  MEAL_SLOT_ORDER,
  MealLogStatus,
  MealSlot,
  MessageType,
  NotificationAudience,
  NotificationChannel,
  NotificationEvent,
  NotificationTiming,
  PERMISSIONS,
  PackageStatus,
  PaymentMethod,
  PaymentStatus,
  PhotoReviewStatus,
  PlanStatus,
  QuestionPriority,
  QuestionStatus,
  ROUTES,
  RULES,
  SOCKET_EVENTS,
  ServiceType,
  UserRole,
  UserStatus,
  addDays,
  adherenceRate,
  adminPath,
  ageFromBirthDate,
  badgeMeta,
  badgeTitle,
  bmiCategory,
  calculateBmi,
  calculateBmr,
  calculateTdee,
  clientMessageKey,
  daysBetween,
  deepLink,
  endOfWeek,
  errorMessage,
  formatCallDuration,
  formatCurrencyTr,
  formatDateRangeTr,
  formatDateTr,
  formatDeltaTr,
  formatDurationTr,
  formatNumberTr,
  formatTime,
  formatWeightTr,
  fromDateOnly,
  goalProgress,
  groupBy,
  hydrationRatio,
  initials,
  isKnownBadge,
  isSameDay,
  isoDayOfWeek,
  lowerTr,
  mealSlotLabel,
  minutesToTime,
  nullifyEmpty,
  overlaps,
  paginated,
  randomId,
  sortBySlot,
  startOfWeek,
  timeToMinutes,
  toDateOnly,
  trDayLong,
  trDayShort,
  trMonthName,
  truncate,
  unique,
  upperTr,
  zActivateAccountInput,
  zActivatePackageInput,
  zApiError,
  zApplyTemplateInput,
  zAppointment,
  zAppointmentQuery,
  zAssignClientsInput,
  zAuditLogEntry,
  zAuditQuery,
  zAuthTokens,
  zAvailability,
  zAvailabilityQuery,
  zBadge,
  zBroadcastInput,
  zBusinessReport,
  zCall,
  zCallSignal,
  zChangePasswordInput,
  zClientDetail,
  zClientListItem,
  zClientListQuery,
  zCompositeDish,
  zCompositeDishPart,
  zConsentRecord,
  zConversationListItem,
  zCreateAppointmentInput,
  zCreateClientInput,
  zCreateDataRequestInput,
  zCreateMealLibraryItemInput,
  zCreateMealPhotoInput,
  zCreateMeasurementInput,
  zCreatePackageInput,
  zCreatePlanInput,
  zCreateRecipeInput,
  zCreateTemplateInput,
  zDashboard,
  zDataRequest,
  zDateOnly,
  zDateTime,
  zDayPlanView,
  zDeliveryQuery,
  zDietPlan,
  zDietaryRule,
  zEmail,
  zExchangeDayTally,
  zExchangeGroup,
  zExchangeItem,
  zExchangeLibrary,
  zExchangePortion,
  zExchangePrescription,
  zExchangeSlotPortion,
  zForgotPasswordInput,
  zGenerateShoppingListInput,
  zGiveConsentInput,
  zHistoryDay,
  zHistoryWeek,
  zIceServers,
  zId,
  zInvitationPreview,
  zInviteTeamMemberInput,
  zLogExchangeInput,
  zLogWaterInput,
  zLoginInput,
  zLoginResponse,
  zMacros,
  zMealAlternative,
  zMealItem,
  zMealLibraryItem,
  zMealLog,
  zMealPhoto,
  zMealPhotoQuery,
  zMeasurement,
  zMessage,
  zMessageListQuery,
  zNotification,
  zNotificationDelivery,
  zNotificationPreferences,
  zNotificationQuery,
  zNotificationRule,
  zOrganizationSettings,
  zPagination,
  zPassword,
  zPendingQuestion,
  zPendingQuestionQuery,
  zPhone,
  zPhotoAiAnalysis,
  zPlanDay,
  zPlanListQuery,
  zPlanMeal,
  zPlanTemplate,
  zPresignUploadInput,
  zPresignUploadResponse,
  zProgressSummary,
  zPublishPlanInput,
  zRecipe,
  zRefreshInput,
  zRegisterPushTokenInput,
  zRenewPackageInput,
  zReportQuery,
  zRequestRescheduleInput,
  zResetPasswordInput,
  zResolveDataRequestInput,
  zSaveExchangePrescriptionInput,
  zSendMessageInput,
  zSendPhotoFeedbackInput,
  zServicePackage,
  zSessionUser,
  zSetMealLogInput,
  zShoppingList,
  zShoppingListItem,
  zSortOrder,
  zStartCallInput,
  zStoredFile,
  zStreak,
  zSyncStepsInput,
  zTeamMember,
  zTime,
  zTodaySummary,
  zUpdateAppointmentInput,
  zUpdateClientInput,
  zUpdateMeasurementInput,
  zUpdateNotificationRuleInput,
  zUpdateOrganizationSettingsInput,
  zUpdatePlanInput,
  zUpdateProfileInput,
  zUpdateQuestionInput,
  zUpdateShoppingItemInput,
  zUpdateTeamMemberInput,
  zUpsertDietaryRuleInput,
  zUpsertExchangeItemInput,
  zVerifyPaymentInput,
  zWaterDay,
  zWeeklyReportInput,
  zWellbeingInput,
  zWellbeingLog
};
